/*
 * Shrine Pro storefront runtime, audited production build.
 * Public custom elements, Shopify cart routes, event names and Liquid selectors
 * are preserved. String-table obfuscation and unused runtime lookup code were
 * removed. See FINAL_SECURITY_AUDIT.md for the dependency and request map.
 */

const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    variantChange: "variant-change",
  };
const subscribers = Object.create(null);
// Form properties are inserted into generated hidden inputs. Escape attribute
// values so merchant supplied text cannot break the form's markup.
function escapeHtmlAttribute(value) {
  const entities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  };
  return String(value).replace(/[&<>"']/g, (character) => entities[character]);
}
function subscribe(eventName, callback) {
  subscribers[eventName] ||= [];
  subscribers[eventName].push(callback);
  return () => {
    subscribers[eventName] = subscribers[eventName].filter(
      (listener) => listener !== callback,
    );
  };
}
function publish(eventName, data) {
  subscribers[eventName]?.forEach((listener) => listener(data));
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (parameter_0011) => {
      parameter_0011.preventDefault();
      const value_0013 =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      this.clearCart
        ? value_0013.clearCart()
        : value_0013.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    const value_0015 = debounce((parameter_0016) => {
      this.onChange(parameter_0016);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", value_0015.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (parameter_0019) => {
        if (parameter_0019.source === "cart-items") return;
        this.onCartUpdate();
      },
    );
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(parameter_0022) {
    this.updateQuantity(
      parameter_0022.target.dataset.index,
      parameter_0022.target.value,
      document.activeElement.getAttribute("name"),
    );
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((parameter_0025) => parameter_0025.text())
      .then((parameter_0026) => {
        const documentFragment_0028 = new DOMParser().parseFromString(
            parameter_0026,
            "text/html",
          ),
          element_0029 = documentFragment_0028.querySelector("cart-items");
        this.innerHTML = element_0029.innerHTML;
      })
      ["catch"]((parameter_0030) => {
        console.error(parameter_0030);
      });
  }
  updateCart() {
    const payload_0033 = JSON.stringify({
      sections: this.getSectionsToRender().map(
        (parameter_0034) => parameter_0034.section,
      ),
      sections_url: window.location.pathname,
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: payload_0033,
    })
      .then((parameter_0035) => parameter_0035.json())
      .then((parameter_0036) => {
        this.classList.toggle("is-empty", parameter_0036.item_count === 0);
        this.getSectionsToRender().forEach((parameter_0038) => {
          const value_0040 =
            document
              .getElementById(parameter_0038.id)
              .querySelector(parameter_0038.selector) ||
            document.getElementById(parameter_0038.id);
          value_0040.innerHTML = this.getSectionInnerHTML(
            parameter_0036.sections[parameter_0038.section],
            parameter_0038.selector,
          );
        });
      })
      ["catch"]((parameter_0041) => {
        console.error(parameter_0041);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  async updateQuantity(parameter_0044, parameter_0045, parameter_0046) {
    this.enableLoading(parameter_0044);
    const payload_0048 = JSON.stringify({
      line: parameter_0044,
      quantity: parameter_0045,
      sections: this.getSectionsToRender().map(
        (parameter_0049) => parameter_0049.section,
      ),
      sections_url: window.location.pathname,
    });
    try {
      const value_0050 = await fetch("" + routes.cart_change_url, {
          ...fetchConfig(),
          ...{
            body: payload_0048,
          },
        }),
        value_0051 = await value_0050.text(),
        value_0052 = JSON.parse(value_0051),
        value_0053 =
          document.getElementById("Quantity-" + parameter_0044) ||
          document.getElementById("Drawer-quantity-" + parameter_0044),
        elements_0054 = document.querySelectorAll(".cart-item");
      if (value_0052.errors) {
        value_0053.value = value_0053.getAttribute("value");
        this.updateLiveRegions(parameter_0044, value_0052.errors);
        return;
      }
      if (!value_0052.sections) {
        const value_0060 = await fetch(
          routes.cart_url +
            "?sections=" +
            this.getSectionsToRender()
              .map((parameter_0061) => parameter_0061.section)
              .join(","),
        );
        value_0052.sections = await value_0060.json();
      }
      this.classList.toggle("is-empty", value_0052.item_count === 0);
      const element_0055 = document.querySelector("cart-drawer"),
        value_0056 = document.getElementById("main-cart-footer");
      if (value_0056)
        value_0056.classList.toggle("is-empty", value_0052.item_count === 0);
      if (element_0055)
        element_0055.classList.toggle("is-empty", value_0052.item_count === 0);
      this.getSectionsToRender().forEach((parameter_0062) => {
        const value_0064 =
          document
            .getElementById(parameter_0062.id)
            .querySelector(parameter_0062.selector) ||
          document.getElementById(parameter_0062.id);
        value_0064.innerHTML = this.getSectionInnerHTML(
          value_0052.sections[parameter_0062.section],
          parameter_0062.selector,
        );
      });
      const value_0057 = value_0052.items[parameter_0044 - 1]
        ? value_0052.items[parameter_0044 - 1].quantity
        : undefined;
      let value_0058 = "";
      elements_0054.length === value_0052.items.length &&
        value_0057 !== parseInt(value_0053.value) &&
        (typeof value_0057 === "undefined"
          ? (value_0058 = window.cartStrings.error)
          : (value_0058 = window.cartStrings.quantityError.replace(
              "[quantity]",
              value_0057,
            )));
      this.updateLiveRegions(parameter_0044, value_0058);
      const value_0059 =
        document.getElementById("CartItem-" + parameter_0044) ||
        document.getElementById("CartDrawer-Item-" + parameter_0044);
      if (
        value_0059 &&
        value_0059.querySelector('[name="' + parameter_0046 + '"]')
      )
        element_0055
          ? trapFocus(
              element_0055,
              value_0059.querySelector('[name="' + parameter_0046 + '"]'),
            )
          : value_0059.querySelector('[name="' + parameter_0046 + '"]').focus();
      else {
        if (value_0052.item_count === 0 && element_0055)
          trapFocus(
            element_0055.querySelector(".drawer__inner-empty"),
            element_0055.querySelector("a"),
          );
        else
          document.querySelector(".cart-item") &&
            element_0055 &&
            trapFocus(element_0055, document.querySelector(".cart-item__name"));
      }
      if (element_0055) {
        element_0055.checkForClear();
        const element_0065 = element_0055.querySelector("countdown-timer");
        if (element_0065) element_0065.playTimer();
        if (element_0055.querySelector("cart-drawer-gift")) {
          element_0055.checkForClear();
          let value_0066 = [],
            value_0067 = [];
          element_0055
            .querySelectorAll("cart-drawer-gift")
            .forEach((parameter_0068) => {
              parameter_0068.getUpdateRequired() &&
                (element_0055.querySelector(
                  ".cart-item--product-" + parameter_0068.dataset.handle,
                )
                  ? parameter_0068.dataset.selected === "false" &&
                    value_0067.push(parameter_0068)
                  : parameter_0068.dataset.selected === "true" &&
                    value_0066.push(parameter_0068));
            });
          if (value_0067.length > 0) value_0067[0].removeFromCart();
          else value_0066.length > 0 && value_0066[0].addToCart();
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
      });
    } catch (value_0070) {
      this.querySelectorAll(".loading-overlay").forEach((parameter_0072) =>
        parameter_0072.classList.add("hidden"),
      );
      const value_0071 =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      value_0071.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(parameter_0044);
      if (this.secondCartItems && this.secondCartItems.updateCart)
        this.secondCartItems.updateCart();
      const value_0073 = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle",
        },
      });
      document.dispatchEvent(value_0073);
    }
  }
  updateLiveRegions(parameter_0074, parameter_0075) {
    const value_0077 =
      document.getElementById("Line-item-error-" + parameter_0074) ||
      document.getElementById("CartDrawer-LineItemError-" + parameter_0074);
    if (value_0077)
      value_0077.querySelector(".cart-item__error-text").textContent =
        parameter_0075;
    this.lineItemStatusElement.setAttribute("aria-hidden", !false);
    const value_0078 =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    value_0078.setAttribute("aria-hidden", false);
    setTimeout(() => {
      value_0078.setAttribute("aria-hidden", !false);
    }, 1000);
  }
  getSectionInnerHTML(parameter_0080, parameter_0081) {
    return new DOMParser()
      .parseFromString(parameter_0080, "text/html")
      .querySelector(parameter_0081).innerHTML;
  }
  enableLoading(parameter_0083) {
    const value_0085 =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    value_0085.classList.add("cart__items--disabled");
    const elements_0086 = this.querySelectorAll(
        "#CartItem-" + parameter_0083 + " .loading-overlay",
      ),
      elements_0087 = this.querySelectorAll(
        "#CartDrawer-Item-" + parameter_0083 + " .loading-overlay",
      );
    [...elements_0086, ...elements_0087].forEach((parameter_0088) =>
      parameter_0088.classList.remove("hidden"),
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(parameter_0089) {
    const value_0091 =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    value_0091.classList.remove("cart__items--disabled");
    const elements_0092 = this.querySelectorAll(
        "#CartItem-" + parameter_0089 + " .loading-overlay",
      ),
      elements_0093 = this.querySelectorAll(
        "#CartDrawer-Item-" + parameter_0089 + " .loading-overlay",
      );
    elements_0092.forEach((parameter_0094) =>
      parameter_0094.classList.add("hidden"),
    );
    elements_0093.forEach((parameter_0095) =>
      parameter_0095.classList.add("hidden"),
    );
  }
  clearCart() {
    const payload_0097 = JSON.stringify({
      sections: this.getSectionsToRender().map(
        (parameter_0098) => parameter_0098.section,
      ),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: payload_0097,
      },
    })
      .then((parameter_0099) => {
        return parameter_0099.text();
      })
      .then((parameter_0101) => {
        const value_0103 = JSON.parse(parameter_0101);
        this.classList.add("is-empty");
        const element_0104 = document.querySelector("cart-drawer"),
          value_0105 = document.getElementById("main-cart-footer");
        if (value_0105) value_0105.classList.add("is-empty");
        if (element_0104) element_0104.classList.add("is-empty");
        this.getSectionsToRender().forEach((parameter_0106) => {
          const value_0108 =
            document
              .getElementById(parameter_0106.id)
              .querySelector(parameter_0106.selector) ||
            document.getElementById(parameter_0106.id);
          value_0108.innerHTML = this.getSectionInnerHTML(
            value_0103.sections[parameter_0106.section],
            parameter_0106.selector,
          );
        });
        element_0104 &&
          trapFocus(
            element_0104.querySelector(".drawer__inner-empty"),
            element_0104.querySelector("a"),
          );
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
        });
      })
      ["catch"](() => {
        this.querySelectorAll(".loading-overlay").forEach((parameter_0111) =>
          parameter_0111.classList.add("hidden"),
        );
        const value_0110 =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        value_0110.textContent = window.cartStrings.error;
      });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
!customElements.get("cart-note") &&
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          "change",
          debounce((parameter_0113) => {
            const payload_0115 = JSON.stringify({
              note: parameter_0113.target.value,
            });
            fetch("" + routes.cart_update_url, {
              ...fetchConfig(),
              ...{
                body: payload_0115,
              },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
function handleDiscountForm(event) {
  event.preventDefault();
  const codeInput = event.target.querySelector('[name="cart-discount-field"]');
  const error = event.target.querySelector(".cart-discount-form__error");
  const code = codeInput?.value.trim();
  if (!code) {
    if (error) error.style.display = "block";
    return;
  }
  if (error) error.style.display = "none";
  window.location.href = "/checkout?discount=" + encodeURIComponent(code);
}
function handleDiscountFormChange() {
  document.querySelectorAll(".cart-discount-form__error").forEach((error) => {
    error.style.display = "none";
  });
}
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.input &&
      (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
      this.input.addEventListener(
        "input",
        debounce((parameter_0129) => {
          this.onChange(parameter_0129);
        }, 300).bind(this),
      ));
  }
  toggleResetButton() {
    const value_0131 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && value_0131)
      this.resetButton.classList.remove("hidden");
    else
      this.input.value.length === 0 &&
        !value_0131 &&
        this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(parameter_0134) {
    parameter_0134.preventDefault();
    this.shouldResetForm() &&
      ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const value_0140 = this.getQuery();
    (!this.searchTerm || !value_0140.startsWith(this.searchTerm)) &&
      this.querySelector("#predictive-search-results-groups-wrapper")?.[
        "remove"
      ]();
    this.updateSearchForTerm(this.searchTerm, value_0140);
    this.searchTerm = value_0140;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(parameter_0141) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      parameter_0141.preventDefault();
  }
  onFormReset(parameter_0143) {
    super.onFormReset(parameter_0143);
    super.shouldResetForm() &&
      ((this.searchTerm = ""),
      this.abortController.abort(),
      (this.abortController = new AbortController()),
      this.closeResults(true));
  }
  onFocus() {
    const value_0146 = this.getQuery();
    if (!value_0146.length) return;
    if (this.searchTerm !== value_0146) this.onChange();
    else
      this.getAttribute("results") === "true"
        ? this.open()
        : this.getSearchResults(this.searchTerm);
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onKeyup(parameter_0148) {
    if (!this.getQuery().length) this.close(true);
    parameter_0148.preventDefault();
    switch (parameter_0148.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(parameter_0150) {
    (parameter_0150.code === "ArrowUp" ||
      parameter_0150.code === "ArrowDown") &&
      parameter_0150.preventDefault();
  }
  updateSearchForTerm(parameter_0152, parameter_0153) {
    const element_0155 = this.querySelector(
        "[data-predictive-search-search-for-text]",
      ),
      value_0156 = element_0155?.["innerText"];
    if (value_0156) {
      if (value_0156.match(new RegExp(parameter_0152, "g")).length > 1) return;
      const value_0157 = value_0156.replace(parameter_0152, parameter_0153);
      element_0155.innerText = value_0157;
    }
  }
  switchOption(parameter_0158) {
    if (!this.getAttribute("open")) return;
    const value_0160 = parameter_0158 === "up",
      element_0161 = this.querySelector('[aria-selected="true"]'),
      value_0162 = Array.from(
        this.querySelectorAll("li, button.predictive-search__item"),
      ).filter((parameter_0167) => parameter_0167.offsetParent !== null);
    let value_0163 = 0;
    if (value_0160 && !element_0161) return;
    let value_0164 = -1,
      value_0165 = 0;
    while (value_0164 === -1 && value_0165 <= value_0162.length) {
      value_0162[value_0165] === element_0161 && (value_0164 = value_0165);
      value_0165++;
    }
    this.statusElement.textContent = "";
    if (!value_0160 && element_0161)
      value_0163 = value_0164 === value_0162.length - 1 ? 0 : value_0164 + 1;
    else
      value_0160 &&
        (value_0163 =
          value_0164 === 0 ? value_0162.length - 1 : value_0164 - 1);
    if (value_0163 === value_0164) return;
    const value_0166 = value_0162[value_0163];
    value_0166.setAttribute("aria-selected", true);
    if (element_0161) element_0161.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", value_0166.id);
  }
  selectOption() {
    const element_0169 = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]',
    );
    if (element_0169) element_0169.click();
  }
  getSearchResults(parameter_0170) {
    const value_0172 = parameter_0170.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[value_0172]) {
      this.renderSearchResults(this.cachedResults[value_0172]);
      return;
    }
    fetch(
      routes.predictive_search_url +
        "?q=" +
        encodeURIComponent(parameter_0170) +
        "&section_id=predictive-search",
      {
        signal: this.abortController.signal,
      },
    )
      .then((parameter_0173) => {
        if (!parameter_0173.ok) {
          var value_0175 = new Error(parameter_0173.status);
          this.close();
          throw value_0175;
        }
        return parameter_0173.text();
      })
      .then((parameter_0176) => {
        const value_0178 = new DOMParser()
          .parseFromString(parameter_0176, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach((parameter_0179) => {
          parameter_0179.cachedResults[value_0172] = value_0178;
        });
        this.renderSearchResults(value_0178);
      })
      ["catch"]((parameter_0181) => {
        if (parameter_0181?.["code"] === 20) return;
        this.close();
        throw parameter_0181;
      });
  }
  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText(parameter_0184) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = parameter_0184;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(parameter_0187) {
    this.predictiveSearchResults.innerHTML = parameter_0187;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        .textContent,
    );
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight -
        document.querySelector(".section-header").getBoundingClientRect()
          .bottom),
      this.resultsMaxHeight
    );
  }
  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close(parameter_0192 = false) {
    this.closeResults(parameter_0192);
    this.isOpen = false;
  }
  closeResults(parameter_0194 = false) {
    parameter_0194 &&
      ((this.input.value = ""), this.removeAttribute("results"));
    const element_0196 = this.querySelector('[aria-selected="true"]');
    if (element_0196) element_0196.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.checkForClear();
    this.addEventListener(
      "keyup",
      (parameter_0198) => parameter_0198.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const element_0200 = document.querySelector("#cart-icon-bubble"),
      value_0201 = element_0200.closest(".header__icons");
    element_0200.setAttribute("role", "button");
    element_0200.setAttribute("aria-haspopup", "dialog");
    element_0200.addEventListener("click", (parameter_0202) => {
      parameter_0202.preventDefault();
      this.open(element_0200);
    });
    this.oseid = value_0201.querySelector("form").dataset[this.dataset.type];
    element_0200.addEventListener("keydown", (parameter_0204) => {
      parameter_0204.code.toUpperCase() === "SPACE" &&
        (parameter_0204.preventDefault(), this.open(element_0200));
    });
  }
  open(parameter_0206) {
    if (parameter_0206) this.setActiveElement(parameter_0206);
    const element_0208 = this.querySelector('[id^="Details-"] summary');
    if (element_0208 && !element_0208.hasAttribute("role"))
      this.setSummaryAccessibility(element_0208);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const value_0212 = this.classList.contains("is-empty")
            ? this.querySelector(".drawer__inner-empty")
            : document.getElementById("CartDrawer"),
          value_0213 =
            this.querySelector(".drawer__inner") ||
            this.querySelector(".drawer__close");
        trapFocus(value_0212, value_0213);
      },
      {
        once: true,
      },
    );
    document.body.classList.add("overflow-hidden");
    const element_0209 = this.querySelector("countdown-timer");
    if (element_0209) element_0209.playTimer();
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const elements_0216 = this.querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
      ),
      value_0217 = [];
    return (
      elements_0216.forEach((parameter_0218) => {
        parameter_0218.dataset.handle &&
          value_0217.push(parameter_0218.dataset.handle);
      }),
      value_0217
    );
  }
  oneNonUpellRemaining() {
    const elements_0221 = this.querySelectorAll(".cart-item");
    let value_0222 = 0;
    return (
      elements_0221.forEach((parameter_0223) => {
        this.upsellHandles.forEach((parameter_0225) => {
          parameter_0223.classList.contains(
            "cart-item--product-" + parameter_0225,
          ) && value_0222++;
        });
      }),
      elements_0221.length - value_0222 <= 1
    );
  }
  checkForClear() {
    const value_0228 = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach((parameter_0229) => {
      value_0228
        ? (parameter_0229.clearCart = true)
        : (parameter_0229.clearCart = false);
    });
  }
  setSummaryAccessibility(parameter_0231) {
    parameter_0231.setAttribute("role", "button");
    parameter_0231.setAttribute("aria-expanded", "false");
    parameter_0231.nextElementSibling.getAttribute("id") &&
      parameter_0231.setAttribute(
        "aria-controls",
        parameter_0231.nextElementSibling.id,
      );
    parameter_0231.addEventListener("click", (parameter_0233) => {
      parameter_0233.currentTarget.setAttribute(
        "aria-expanded",
        !parameter_0233.currentTarget.closest("details").hasAttribute("open"),
      );
    });
    parameter_0231.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(parameter_0235, parameter_0236 = false) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parameter_0235.id;
    this.getSectionsToRender().forEach((parameter_0241) => {
      const value_0243 = parameter_0241.selector
        ? document.querySelector(parameter_0241.selector)
        : document.getElementById(parameter_0241.id);
      if (value_0243)
        value_0243.innerHTML = this.getSectionInnerHTML(
          parameter_0235.sections[parameter_0241.id],
          parameter_0241.selector,
        );
    });
    this.checkForClear();
    const element_0238 = this.querySelector("countdown-timer");
    if (element_0238 && element_0238.playTimer) element_0238.playTimer();
    let value_0239 = [],
      value_0240 = [];
    this.querySelectorAll("cart-drawer-gift").forEach((parameter_0244) => {
      parameter_0244.getUpdateRequired() &&
        (this.querySelector(
          ".cart-item--product-" + parameter_0244.dataset.handle,
        )
          ? parameter_0244.dataset.selected === "false" &&
            value_0240.push(parameter_0244)
          : parameter_0244.dataset.selected === "true" &&
            value_0239.push(parameter_0244));
    });
    if (value_0240.length > 0) value_0240[0].removeFromCart();
    else value_0239.length > 0 && value_0239[0].addToCart();
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      if (parameter_0236) return;
      this.open();
    });
  }
  getSectionInnerHTML(parameter_0247, parameter_0248 = ".shopify-section") {
    let element_0250 = new DOMParser()
      .parseFromString(parameter_0247, "text/html")
      .querySelector(parameter_0248);
    parameter_0248 === "#CartDrawer" && fixParsedHtml(this, element_0250);
    let value_0251 = element_0250.innerHTML;
    return value_0251;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }
  getSectionDOM(parameter_0253, parameter_0254 = ".shopify-section") {
    return new DOMParser()
      .parseFromString(parameter_0253, "text/html")
      .querySelector(parameter_0254);
  }
  setActiveElement(parameter_0256) {
    this.activeElement = parameter_0256;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    })
      .then((parameter_0259) => parameter_0259.json())
      .then((parameter_0260) => {
        document
          .querySelector("cart-drawer")
          .renderContents(parameter_0260, true);
      })
      ["catch"]((parameter_0262) => {
        console.error(parameter_0262);
      });
  }
  getSectionInnerHTML(parameter_0263, parameter_0264) {
    let element_0266 = new DOMParser()
      .parseFromString(parameter_0263, "text/html")
      .querySelector(parameter_0264);
    parameter_0264 === ".drawer__inner" &&
      fixParsedHtml(this.cartDrawer, element_0266);
    let value_0267 = element_0266.innerHTML;
    return value_0267;
  }
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(currentDrawer, nextDrawer) {
  const nextTimer = nextDrawer.querySelector(".cart-timer");
  const currentTimer = currentDrawer.querySelector(".cart-timer");
  if (nextTimer && currentTimer) nextTimer.innerHTML = currentTimer.innerHTML;

  const selector = 'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift';
  const nextOffers = nextDrawer.querySelectorAll(selector);
  currentDrawer.querySelectorAll(selector).forEach((currentOffer, index) => {
    const nextOffer = nextOffers[index];
    if (!nextOffer) return;
    if (currentOffer.localName === "cart-drawer-upsell") {
      nextOffer.dataset.selected = currentOffer.dataset.selected;
    }
    nextOffer.dataset.id = currentOffer.dataset.id;
    const nextId = nextOffer.querySelector('[name="id"]');
    const currentId = currentOffer.querySelector('[name="id"]');
    if (nextId && currentId) nextId.value = currentId.value;
    const nextImage = nextOffer.querySelector(".upsell__image__img");
    const currentImage = currentOffer.querySelector(".upsell__image__img");
    if (nextImage && currentImage) nextImage.src = currentImage.src;

    const currentOptions = currentOffer.querySelectorAll(".select__select");
    nextOffer
      .querySelectorAll(".select__select")
      .forEach((nextSelect, optionIndex) => {
        const currentSelect = currentOptions[optionIndex];
        if (!currentSelect) return;
        nextSelect.value = currentSelect.value;
        nextSelect.querySelectorAll("option").forEach((option) => {
          option.toggleAttribute(
            "selected",
            option.value === currentSelect.value.trim(),
          );
        });
      });
    if (currentOffer.dataset.updatePrices === "true") {
      const nextPrice = nextOffer.querySelector(".upsell__price");
      const currentPrice = currentOffer.querySelector(".upsell__price");
      if (nextPrice && currentPrice)
        nextPrice.innerHTML = currentPrice.innerHTML;
    }
  });
}
!customElements.get("product-form") &&
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.formIdInput = this.form.querySelector("[name=id]");
        this.formIdInput.disabled = false;
        this.isMain = this.classList.contains("main-product-form");
        this.additionalAtcButtons = this.isMain
          ? document.querySelectorAll(".main-product-atc")
          : [];
        this.skipCart = this.formIdInput.dataset.skipCart === "true";
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");
        this.isCartUpsell = this.dataset.isCartUpsell === "true";
        this.submitButton = this.querySelector('[type="submit"]');
        document.querySelector("cart-drawer") &&
          (this.submitButton.setAttribute("aria-haspopup", "dialog"),
          (this.hasDrawer = true));
        this.loadingSpinner = this.submitButton.querySelector(
          ".loading-overlay__spinner",
        );
        this.displayedSubmitButton = document.getElementById(
          "DisplayedSubmitBtn-" + this.dataset.section,
        );
        this.bundleDeals = document.getElementById(
          "bundle-deals-" + this.dataset.section,
        );
        this.productInfo = document.getElementById(
          "ProductInfo-" + this.dataset.section,
        );
        this.quantityBreaks = document.getElementById(
          "quantity-breaks-" + this.dataset.section,
        );
        this.quantityPicker = document.getElementById(
          "Quantity-Form-" + this.dataset.section,
        );
        this.customFields = document.querySelectorAll(
          "[id^='CustomField-" + this.dataset.section + "-']",
        );
        this.quantityGifts = document.getElementById(
          "quantity-gifts-" + this.dataset.section,
        );
        this.upsells = document.querySelectorAll(
          ".product-info-upsell-" + this.dataset.section,
        );
        this.mainBundleItems = document.querySelectorAll(
          ".main-offer-item-" + this.dataset.section,
        );
        this.variantInputs = this.form.querySelector(".product-form__variants");
      }
      handleSubmit(parameter_0287) {
        let value_0289 = null,
          value_0290 = false;
        parameter_0287 &&
          (parameter_0287.preventDefault(),
          parameter_0287.currentTarget.classList.contains(
            "button--has-spinner",
          ) &&
            ((value_0289 = parameter_0287.currentTarget),
            value_0289.classList.add("loading")),
          parameter_0287.currentTarget.dataset.skipCartButton === "true" &&
            (value_0290 = true));
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        if (!value_0289) {
          this.submitButton.classList.add("loading");
          if (this.loadingSpinner)
            this.loadingSpinner.classList.remove("hidden");
        }
        this.additionalAtcButtons.forEach((parameter_0294) => {
          parameter_0294.setAttribute("disabled", "");
        });
        this.displayedSubmitButton &&
          (this.displayedSubmitButton.setAttribute("disabled", ""),
          this.displayedSubmitButton.classList.add("loading"));
        let value_0291 = false;
        if (this.variantInputs) {
          this.variantInputs.innerHTML = "";
          let value_0296 = "",
            value_0297 = [];
          this.hasDrawer &&
            !this.isCartUpsell &&
            !this.skipCart &&
            this.cart
              .querySelectorAll(
                'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
              )
              .forEach((parameter_0298) => {
                parameter_0298.dataset.selected === "true" &&
                  !this.cart.querySelector(
                    ".cart-item--product-" + parameter_0298.dataset.handle,
                  ) &&
                  value_0297.unshift(parameter_0298.dataset.id);
              });
          if (this.bundleDeals) {
            value_0291 = true;
            this.dataset.includePdpUpsells === "true" &&
              document
                .querySelectorAll("product-info-upsell")
                .forEach((parameter_0301) => {
                  if (parameter_0301.dataset.selected === "true")
                    value_0297.unshift(parameter_0301.dataset.id);
                });
            for (
              let value_0303 = 0;
              value_0303 < value_0297.length;
              value_0303++
            ) {
              value_0296 +=
                '<input type="hidden" name="items[' +
                value_0303 +
                '][quantity]" value="1"><input type="hidden" name="items[' +
                value_0303 +
                '][id]" value="' +
                value_0297[value_0303] +
                '">';
            }
            let value_0300 = value_0297.length;
            for (
              let value_0304 = 0;
              value_0304 < this.bundleDeals.formVariants.length;
              value_0304++
            ) {
              const value_0305 = this.bundleDeals.formVariants[value_0304];
              value_0296 +=
                '<input type="hidden" name="items[' +
                (value_0304 + value_0300) +
                '][quantity]" value="' +
                value_0305.quantity +
                '"><input type="hidden" name="items[' +
                (value_0304 + value_0300) +
                '][id]" value="' +
                value_0305.id +
                '">';
            }
            this.variantInputs.innerHTML = value_0296;
          } else {
            let value_0306 = [];
            this.quantityGifts &&
              this.quantityGifts.unlockedItems.length > 0 &&
              (value_0297 = [
                ...value_0297,
                ...this.quantityGifts.unlockedItems,
              ]);
            for (
              let value_0307 = this.upsells.length - 1;
              value_0307 >= 0;
              value_0307--
            ) {
              this.upsells[value_0307].dataset.selected === "true" &&
                value_0297.push(this.upsells[value_0307].dataset.id);
            }
            if (this.mainBundleItems.length === 0) {
              if (
                this.quantityBreaks &&
                this.quantityBreaks.formVariants.length > 0
              ) {
                value_0297 = [
                  ...value_0297,
                  ...this.quantityBreaks.formVariants,
                ];
                value_0306 = [...this.quantityBreaks.formVariants];
              } else {
                if (
                  value_0297.length > 0 &&
                  (!this.quantityBreaks ||
                    this.quantityBreaks.formVariants.length === 0)
                ) {
                  let value_0308 = 1;
                  if (this.quantityBreaks)
                    value_0308 = this.quantityBreaks.selectedQuantity;
                  else
                    this.quantityPicker &&
                      (value_0308 = parseInt(
                        this.quantityPicker.querySelector(".quantity__input")
                          .value,
                      ));
                  for (
                    let value_0309 = 0;
                    value_0309 < value_0308;
                    value_0309++
                  ) {
                    value_0297.push(this.formIdInput.value);
                  }
                  value_0306 = [this.formIdInput.value];
                }
              }
            }
            for (
              let value_0310 = this.mainBundleItems.length - 1;
              value_0310 >= 0;
              value_0310--
            ) {
              value_0297.push(this.mainBundleItems[value_0310].dataset.id);
              value_0306.push(this.mainBundleItems[value_0310].dataset.id);
            }
            if (value_0297.length > 0) {
              value_0291 = true;
              const value_0311 = [];
              for (
                let value_0313 = 0;
                value_0313 < value_0297.length;
                value_0313++
              ) {
                const value_0314 = value_0297[value_0313],
                  value_0315 = value_0311.findIndex(
                    (parameter_0316) => parameter_0316.id === value_0314,
                  );
                value_0315 < 0
                  ? value_0311.push({
                      id: value_0314,
                      quantity: 1,
                    })
                  : (value_0311[value_0315].quantity += 1);
              }
              let value_0312 = [];
              this.customFields.forEach((parameter_0317) => {
                parameter_0317.dataset.disabled != "true" &&
                  value_0312.push({
                    fieldName: parameter_0317.fieldName,
                    value: parameter_0317.prevValue,
                  });
              });
              this.classList.contains("main-product-form") &&
                ((this.sellingPlanInput =
                  this.querySelector(
                    '.appstle-active-option [name="selling_plan"]',
                  ) ||
                  this.querySelector('[name="selling_plan"]') ||
                  document.querySelector(
                    '.sls-purchase [name="selling_plan"]',
                  )),
                (this.simpleBundlesContainer = this.querySelector(
                  "#simple-bundles-io-options",
                )),
                (this.appPropertyInputs = document.querySelectorAll(
                  '.cl-upload--wrapper input[name^="properties["], .uploadkit-attribute-container input[name^="properties["], .gpo-hidden-inputs input:not(#validator)',
                )));
              for (
                let value_0319 = 0;
                value_0319 < value_0311.length;
                value_0319++
              ) {
                const value_0320 = value_0311[value_0319];
                value_0296 +=
                  '<input type="hidden" name="items[' +
                  value_0319 +
                  '][quantity]" value="' +
                  value_0320.quantity +
                  '"><input type="hidden" name="items[' +
                  value_0319 +
                  '][id]" value="' +
                  value_0320.id +
                  '">';
                value_0306.includes(value_0320.id) &&
                  (value_0312.forEach((parameter_0321) => {
                    value_0296 +=
                      '<input type="hidden" name="items[' +
                      value_0319 +
                      "][properties][" +
                      escapeHtmlAttribute(parameter_0321.fieldName) +
                      ']" value="' +
                      escapeHtmlAttribute(parameter_0321.value) +
                      '">';
                  }),
                  this.sellingPlanInput &&
                    typeof this.sellingPlanInput.value === "string" &&
                    this.sellingPlanInput.value.length > 0 &&
                    (value_0296 +=
                      '<input type="hidden" name="items[' +
                      value_0319 +
                      '][selling_plan]" value="' +
                      escapeHtmlAttribute(this.sellingPlanInput.value) +
                      '">'),
                  this.simpleBundlesContainer &&
                    this.simpleBundlesContainer
                      .querySelectorAll("select")
                      .forEach((parameter_0323) => {
                        const value_0325 =
                          parameter_0323.name.match(/properties\[(.*?)\]/);
                        if (value_0325) {
                          let value_0326 = value_0325[1];
                          value_0296 +=
                            '<input type="hidden" name="items[' +
                            value_0319 +
                            "][properties][" +
                            escapeHtmlAttribute(value_0326) +
                            ']" value="' +
                            escapeHtmlAttribute(parameter_0323.value) +
                            '">';
                        }
                      }),
                  this.appPropertyInputs.forEach((parameter_0327) => {
                    const propertyMatch =
                      parameter_0327.name.match(/properties\[(.*?)\]/);
                    if (!propertyMatch) return;
                    let value_0329 = propertyMatch[1];
                    value_0296 +=
                      '<input type="hidden" name="items[' +
                      value_0319 +
                      "][properties][" +
                      escapeHtmlAttribute(value_0329) +
                      ']" value="' +
                      escapeHtmlAttribute(parameter_0327.value) +
                      '">';
                  }));
              }
              this.variantInputs.innerHTML = value_0296;
            }
          }
        }
        var value_0292 = fetchConfig("javascript");
        value_0292.headers["X-Requested-With"] = "XMLHttpRequest";
        delete value_0292.headers["Content-Type"];
        var value_0293 = new FormData(this.form);
        this.cart &&
          (value_0293.append(
            "sections",
            this.cart
              .getSectionsToRender()
              .map((parameter_0330) => parameter_0330.id),
          ),
          value_0293.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement));
        if (value_0291) {
          const value_0331 = this.dataset.options
              ? this.dataset.options.split(",")
              : [],
            value_0332 = ["id", "quantity", ...value_0331];
          for (
            let value_0333 = 0;
            value_0333 < value_0332.length;
            value_0333++
          ) {
            value_0293["delete"](value_0332[value_0333]);
          }
        }
        value_0292.body = value_0293;
        fetch("" + routes.cart_add_url, value_0292)
          .then((parameter_0334) => parameter_0334.json())
          .then((parameter_0335) => {
            if (parameter_0335.status) {
              this.handleErrorMessage(parameter_0335.description);
              const element_0338 =
                this.submitButton.querySelector(".sold-out-message");
              if (!element_0338) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              element_0338.classList.remove("hidden");
              this.error = true;
              return;
            } else {
              if (this.skipCart || value_0290) {
                window.location = "/checkout";
                return;
              } else {
                if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
              }
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
              });
            this.error = false;
            const value_0337 = this.closest("quick-add-modal");
            value_0337
              ? (document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(
                        parameter_0335,
                        this.isCartUpsell,
                      );
                    });
                  },
                  {
                    once: true,
                  },
                ),
                value_0337.hide(true))
              : this.cart.renderContents(parameter_0335, this.isCartUpsell);
          })
          ["catch"]((parameter_0340) => {
            console.error(parameter_0340);
          })
          ["finally"](() => {
            if (value_0289) value_0289.classList.remove("loading");
            else {
              this.submitButton.classList.remove("loading");
              if (this.loadingSpinner)
                this.loadingSpinner.classList.add("hidden");
            }
            this.additionalAtcButtons.forEach((parameter_0343) => {
              parameter_0343.removeAttribute("disabled");
            });
            this.displayedSubmitButton &&
              (this.displayedSubmitButton.removeAttribute("disabled"),
              this.displayedSubmitButton.classList.remove("loading"));
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }
      handleErrorMessage(parameter_0345 = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !parameter_0345);
        parameter_0345 && (this.errorMessage.textContent = parameter_0345);
      }
    },
  );
!customElements.get("product-info") &&
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
        this.form = this.querySelector("#ProductForm-" + this.dataset.section);
        this.hasUrl = this.dataset.url !== null;
      }
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        !this.dataset.originalSection &&
          (this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          ));
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (parameter_0349) => {
            const value_0351 = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (parameter_0349.data.sectionId !== value_0351) return;
            this.updateQuantityRules(
              parameter_0349.data.sectionId,
              parameter_0349.data.html,
            );
            this.setQuantityBoundries();
          },
        );
        if (!this.form) return;
      }
      disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
        this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
      }
      setQuantityBoundries() {
        const value_0354 = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };
        let value_0355 = value_0354.min;
        const value_0356 =
          value_0354.max === null
            ? value_0354.max
            : value_0354.max - value_0354.cartQuantity;
        if (value_0356 !== null) value_0355 = Math.min(value_0355, value_0356);
        if (value_0354.cartQuantity >= value_0354.min)
          value_0355 = Math.min(value_0355, value_0354.step);
        this.input.min = value_0355;
        this.input.max = value_0356;
        this.input.value = value_0355;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
      initShareLinks() {
        const element_0358 = this.querySelector(".share-url-button");
        if (!element_0358) this.shareUrl = true;
      }
      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay",
        ).classList.remove("hidden");
        fetch(
          this.dataset.url +
            "?variant=" +
            this.currentVariant.value +
            "&section_id=" +
            this.dataset.section,
        )
          .then((parameter_0360) => {
            return parameter_0360.text();
          })
          .then((parameter_0362) => {
            const documentFragment_0364 = new DOMParser().parseFromString(
              parameter_0362,
              "text/html",
            );
            this.updateQuantityRules(
              this.dataset.section,
              documentFragment_0364,
            );
            this.setQuantityBoundries();
          })
          ["catch"]((parameter_0365) => {
            console.error(parameter_0365);
          })
          ["finally"](() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay",
            ).classList.add("hidden");
          });
      }
      updateQuantityRules(parameter_0368, parameter_0369) {
        const value_0371 = parameter_0369.getElementById(
            "Quantity-Form-" + parameter_0368,
          ),
          value_0372 = [
            ".quantity__input",
            ".quantity__rules",
            ".quantity__label",
          ];
        for (let value_0373 of value_0372) {
          const element_0374 = this.quantityForm.querySelector(value_0373),
            element_0375 = value_0371.querySelector(value_0373);
          if (!element_0374 || !element_0375) continue;
          if (value_0373 === ".quantity__input") {
            const value_0376 = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let value_0377 of value_0376) {
              const value_0378 = element_0375.getAttribute(value_0377);
              if (value_0378 !== null)
                element_0374.setAttribute(value_0377, value_0378);
            }
          } else element_0374.innerHTML = element_0375.innerHTML;
        }
      }
    },
  );
function getFocusableElements(parameter_0379) {
  return Array.from(
    parameter_0379.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document
  .querySelectorAll('[id^="Details-"] summary')
  .forEach((parameter_0381) => {
    parameter_0381.setAttribute("role", "button");
    parameter_0381.setAttribute(
      "aria-expanded",
      parameter_0381.parentNode.hasAttribute("open"),
    );
    parameter_0381.nextElementSibling.getAttribute("id") &&
      parameter_0381.setAttribute(
        "aria-controls",
        parameter_0381.nextElementSibling.id,
      );
    parameter_0381.addEventListener("click", (parameter_0383) => {
      parameter_0383.currentTarget.setAttribute(
        "aria-expanded",
        !parameter_0383.currentTarget.closest("details").hasAttribute("open"),
      );
    });
    if (parameter_0381.closest("header-drawer")) return;
    parameter_0381.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
const trapFocusHandlers = {};
function trapFocus(parameter_0385, parameter_0386 = parameter_0385) {
  var value_0388 = getFocusableElements(parameter_0385),
    value_0389 = value_0388[0],
    value_0390 = value_0388[value_0388.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (parameter_0391) => {
    if (
      parameter_0391.target !== parameter_0385 &&
      parameter_0391.target !== value_0390 &&
      parameter_0391.target !== value_0389
    )
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (parameter_0394) {
    if (parameter_0394.code.toUpperCase() !== "TAB") return;
    parameter_0394.target === value_0390 &&
      !parameter_0394.shiftKey &&
      (parameter_0394.preventDefault(), value_0389.focus());
    (parameter_0394.target === parameter_0385 ||
      parameter_0394.target === value_0389) &&
      parameter_0394.shiftKey &&
      (parameter_0394.preventDefault(), value_0390.focus());
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  parameter_0386.focus();
  parameter_0386.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(parameter_0386.type) &&
    parameter_0386.value &&
    parameter_0386.setSelectionRange(0, parameter_0386.value.length);
}
function pauseAllMedia() {
  const sendToFrame = (frame, command) => {
    if (!frame.contentWindow || !frame.src) return;
    try {
      frame.contentWindow.postMessage(command, new URL(frame.src, window.location.href).origin);
    } catch (error) {
      console.warn("Media frame could not be paused", error);
    }
  };
  document.querySelectorAll(".js-youtube").forEach((frame) => {
    sendToFrame(frame, '{"event":"command","func":"pauseVideo","args":""}');
  });
  document.querySelectorAll(".js-vimeo").forEach((frame) => {
    sendToFrame(frame, '{"method":"pause"}');
  });
  document
    .querySelectorAll("media-gallery template video")
    .forEach((parameter_0401) => parameter_0401.pause());
  document.querySelectorAll("product-model").forEach((parameter_0402) => {
    if (parameter_0402.modelViewerUI) parameter_0402.modelViewerUI.pause();
  });
}
function removeTrapFocus(parameter_0404 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (parameter_0404) parameter_0404.focus();
}
function onKeyUpEscape(parameter_0406) {
  if (parameter_0406.code.toUpperCase() !== "ESCAPE") return;
  const value_0408 = parameter_0406.target.closest("details[open]");
  if (!value_0408) return;
  const element_0409 = value_0408.querySelector("summary");
  value_0408.removeAttribute("open");
  element_0409.setAttribute("aria-expanded", false);
  element_0409.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true,
    });
    this.quantityGifts = document.getElementById(
      "quantity-gifts-" + this.dataset.section,
    );
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((parameter_0411) =>
      parameter_0411.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(parameter_0414) {
    this.validateQtyRules();
  }
  onButtonClick(parameter_0416) {
    parameter_0416.preventDefault();
    const value_0418 = this.input.value;
    parameter_0416.target.name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown();
    if (value_0418 !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value_0420 = parseInt(this.input.value);
    if (this.input.min) {
      const value_0421 = parseInt(this.input.min),
        element_0422 = this.querySelector(".quantity__button[name='minus']");
      element_0422.classList.toggle("disabled", value_0420 <= value_0421);
    }
    if (this.input.max) {
      const value_0423 = parseInt(this.input.max),
        element_0424 = this.querySelector(".quantity__button[name='plus']");
      element_0424.classList.toggle("disabled", value_0420 >= value_0423);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts)
      this.quantityGifts.unlockGifts(value_0420);
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(callback, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback.apply(this, args), delay);
  };
}
function fetchConfig(responseType = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + responseType,
    },
  };
}
function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
typeof window.Shopify == "undefined" && (window.Shopify = {});
Shopify.bind = function (parameter_0436, parameter_0437) {
  return function () {
    return parameter_0436.apply(parameter_0437, arguments);
  };
};
Shopify.setSelectorByValue = function (parameter_0438, parameter_0439) {
  for (
    var value_0441 = 0, value_0442 = parameter_0438.options.length;
    value_0441 < value_0442;
    value_0441++
  ) {
    var value_0443 = parameter_0438.options[value_0441];
    if (
      parameter_0439 == value_0443.value ||
      parameter_0439 == value_0443.innerHTML
    )
      return ((parameter_0438.selectedIndex = value_0441), value_0441);
  }
};
Shopify.addListener = function (
  parameter_0444,
  parameter_0445,
  parameter_0446,
) {
  parameter_0444.addEventListener
    ? parameter_0444.addEventListener(parameter_0445, parameter_0446, false)
    : parameter_0444.attachEvent("on" + parameter_0445, parameter_0446);
};
Shopify.postLink = function (parameter_0448, parameter_0449) {
  parameter_0449 = parameter_0449 || {};
  var value_0451 = parameter_0449.method || "post",
    value_0452 = parameter_0449.parameters || {},
    value_0453 = document.createElement("form");
  value_0453.setAttribute("method", value_0451);
  value_0453.setAttribute("action", parameter_0448);
  for (var value_0454 in value_0452) {
    var value_0455 = document.createElement("input");
    value_0455.setAttribute("type", "hidden");
    value_0455.setAttribute("name", value_0454);
    value_0455.setAttribute("value", value_0452[value_0454]);
    value_0453.appendChild(value_0455);
  }
  document.body.appendChild(value_0453);
  value_0453.submit();
  document.body.removeChild(value_0453);
};
Shopify.CountryProvinceSelector = function (
  parameter_0456,
  parameter_0457,
  parameter_0458,
) {
  this.countryEl = document.getElementById(parameter_0456);
  this.provinceEl = document.getElementById(parameter_0457);
  this.provinceContainer = document.getElementById(
    parameter_0458.hideElement || parameter_0457,
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value_0461 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value_0461);
    this.countryHandler();
  },
  initProvince: function () {
    var value_0463 = this.provinceEl.getAttribute("data-default");
    value_0463 &&
      this.provinceEl.options.length > 0 &&
      Shopify.setSelectorByValue(this.provinceEl, value_0463);
  },
  countryHandler: function (parameter_0464) {
    var value_0466 = this.countryEl.options[this.countryEl.selectedIndex],
      value_0467 = value_0466.getAttribute("data-provinces"),
      value_0468 = JSON.parse(value_0467);
    this.clearOptions(this.provinceEl);
    if (value_0468 && value_0468.length == 0)
      this.provinceContainer.style.display = "none";
    else {
      for (var value_0469 = 0; value_0469 < value_0468.length; value_0469++) {
        var value_0466 = document.createElement("option");
        value_0466.value = value_0468[value_0469][0];
        value_0466.textContent = value_0468[value_0469][1];
        this.provinceEl.appendChild(value_0466);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (parameter_0470) {
    while (parameter_0470.firstChild) {
      parameter_0470.removeChild(parameter_0470.firstChild);
    }
  },
  setOptions: function (parameter_0472, parameter_0473) {
    for (
      var value_0475 = 0, value_0476 = parameter_0473.length;
      value_0475 < parameter_0473.length;
      value_0475++
    ) {
      var value_0477 = document.createElement("option");
      value_0477.value = parameter_0473[value_0475];
      value_0477.textContent = parameter_0473[value_0475];
      parameter_0472.appendChild(value_0477);
    }
  },
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector(
      'source[type="application/x-mpegURL"]',
    );
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    if (this.playButton)
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    if (this.soundButton)
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    if (this.video)
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    this.timeline &&
      (this.video.addEventListener(
        "timeupdate",
        this.updateTimeline.bind(this),
      ),
      this.timeline.addEventListener("click", this.seekVideo.bind(this)),
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this)),
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this)),
      document.addEventListener("mouseup", this.stopDrag.bind(this)),
      document.addEventListener("touchend", this.stopDrag.bind(this)),
      document.addEventListener("mousemove", this.drag.bind(this)),
      document.addEventListener("touchmove", this.drag.bind(this)));
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const value_0479 = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };
      this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        value_0479,
      );
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      !this.loaded && (this.video.load(), (this.loaded = true));
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn)
        this.playButton.style.visibility = "hidden";
      const value_0481 = this.video.play();
      value_0481 !== undefined &&
        value_0481
          .then(() => {
            this.classList.add("internal-video--playing");
            if (this.playButton && this.noPlayBtn)
              this.playButton.style.visibility = "hidden";
          })
          ["catch"]((parameter_0483) => {
            this.classList.remove("internal-video--playing");
            if (this.playButton && this.noPlayBtn)
              this.playButton.style.visibility = "visible";
          });
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted
      ? ((this.video.muted = false),
        this.classList.remove("internal-video--muted"))
      : ((this.video.muted = true),
        this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const value_0488 = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty("--completed", value_0488 + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(parameter_0490) {
    parameter_0490.preventDefault();
    this.dragging = true;
    this.drag(parameter_0490);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(parameter_0493) {
    if (!this.dragging) return;
    parameter_0493.touches && (parameter_0493 = parameter_0493.touches[0]);
    this.seekVideo(parameter_0493);
  }
  seekVideo(parameter_0495) {
    const value_0497 = this.timeline.getBoundingClientRect(),
      value_0498 = parameter_0495.clientX - value_0497.left,
      value_0499 = value_0498 / value_0497.width;
    this.video.currentTime = value_0499 * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(parameter_0502) {
    parameter_0502.forEach((parameter_0504) => {
      if (parameter_0504.isIntersecting) {
        for (let value_0507 of this.video.querySelectorAll(
          "source[data-src]",
        )) {
          value_0507.setAttribute("src", value_0507.getAttribute("data-src"));
          value_0507.removeAttribute("data-src");
        }
        this.video.load();
        var value_0506 = this.video.play();
        value_0506 !== undefined &&
          value_0506["catch"]((parameter_0508) => {
            if (parameter_0508.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn)
                this.playButton.style.visibility = "visible";
            }
          }).then(() => {
            this.video.play();
          });
        this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(parameter_0512) {
    const value_0514 = parameter_0512.currentTarget.value;
    this.sliderOverlay.style.width = value_0514 + "%";
    this.sliderLine.style.left = value_0514 + "%";
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();
      else {
        const value_0516 = JSON.parse(localStorage.getItem(this.storageKey)),
          value_0517 = new Date(value_0516.next_display_date);
        currentDate.getTime() > value_0517.getTime() && this.openPopupModal();
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach((parameter_0518) => {
      parameter_0518.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        this.modal.classList.add("popup-modal--active");
        this.overlay.classList.add("popup-overlay--active");
        const value_0521 = addDays(currentDate, parseInt(this.daysFrequency)),
          value_0522 = {
            next_display_date: value_0521,
            dismissed: false,
          };
        localStorage.setItem(this.storageKey, JSON.stringify(value_0522));
        if (this.timer) this.displayPromoTimer();
      },
      parseInt(this.secondsDelay) * 1000 + 3000,
    );
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    const value_0524 = setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      this.totalSeconds <= 0 &&
        (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
    }, 1000);
  }
  updateTimer() {
    let value_0527 = Math.floor(this.totalSeconds / 60);
    if (value_0527.toString().length === 1) value_0527 = "0" + value_0527;
    let value_0528 = this.totalSeconds % 60;
    if (value_0528.toString().length === 1) value_0528 = "0" + value_0528;
    this.minutesSpan.innerText = value_0527;
    this.secondsSpan.innerText = value_0528;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(
      ".section-group__section-one-container",
    );
    this.sectionTwoContainer = this.querySelector(
      ".section-group__section-two-container",
    );
    this.transferSections();
    document.addEventListener(
      "shopify:section:load",
      this.transferSections.bind(this),
    );
  }
  transferSections() {
    this.sectionOne = document.querySelector(
      this.dataset.sectionOneId + " .content-for-grouping",
    );
    this.sectionTwo = document.querySelector(
      this.dataset.sectionTwoId + " .content-for-grouping",
    );
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length)
      this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length)
      this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    this.dataset.applied === "true"
      ? this.handleClick()
      : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + encodeURIComponent(this.dataset.code))
      .then((parameter_0534) => {
        if (!parameter_0534.ok) throw new Error("Error");
        this.dataset.applied = "true";
        sessionStorage.setItem(
          "discount-" + this.dataset.code + "-applied",
          "true",
        );
      })
      ["catch"]((parameter_0536) => {
        this.dataset.error = "true";
        this.button.disabled = false;
      })
      ["finally"](() => {
        this.dataset.loading = "false";
      });
  }
  reapplyDiscountIfApplicable() {
    const value_0540 = this.dataset.code;
    sessionStorage.getItem("discount-" + value_0540 + "-applied") &&
      ((this.dataset.applied = "true"),
      (this.button.disabled = true),
      setTimeout(() => {
        fetch("/discount/" + encodeURIComponent(value_0540))["catch"](
          (parameter_0542) => {
            this.dataset.applied = "false";
            this.button.disabled = false;
          },
        );
      }, 3000));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]');
    this.insertDates();
    document.addEventListener("shopify:section:load", (parameter_0545) => {
      this.insertDates();
    });
  }
  insertDates() {
    this.elementsToChange.forEach((parameter_0548) => {
      const value_0550 = parameter_0548.dataset.text,
        value_0551 = parseInt(parameter_0548.dataset.minDays),
        value_0552 = parseInt(parameter_0548.dataset.maxDays),
        value_0553 = addDays(currentDate, value_0551);
      let value_0554 = "th";
      const value_0555 = value_0553.getDate();
      if (value_0555 === 1 || value_0555 === 21 || value_0555 === 31)
        value_0554 = "st";
      else {
        if (value_0555 === 2 || value_0555 === 22) value_0554 = "nd";
        else {
          if (value_0555 === 3 || value_0555 === 23) value_0554 = "rd";
        }
      }
      const value_0556 = addDays(currentDate, value_0552);
      let value_0557 = "th";
      const value_0558 = value_0556.getDate();
      if (value_0558 === 1 || value_0558 === 21 || value_0558 === 31)
        value_0557 = "st";
      else {
        if (value_0558 === 2 || value_0558 === 22) value_0557 = "nd";
        else {
          if (value_0558 === 3 || value_0558 === 23) value_0557 = "rd";
        }
      }
      let value_0559, value_0560;
      if (this.dateFormat === "day_dd_mm") {
        value_0559 =
          this.days[value_0553.getDay()] +
          ", " +
          value_0553.getDate() +
          ". " +
          this.months[value_0553.getMonth()];
        value_0560 =
          this.days[value_0556.getDay()] +
          ", " +
          value_0556.getDate() +
          ". " +
          this.months[value_0556.getMonth()];
      } else {
        if (this.dateFormat === "mm_dd") {
          value_0559 =
            this.months[value_0553.getMonth()] +
            " " +
            value_0553.getDate() +
            value_0554;
          value_0560 =
            this.months[value_0556.getMonth()] +
            " " +
            value_0556.getDate() +
            value_0557;
        } else {
          if (this.dateFormat === "dd_mm") {
            value_0559 =
              value_0553.getDate() + ". " + this.months[value_0553.getMonth()];
            value_0560 =
              value_0556.getDate() + ". " + this.months[value_0556.getMonth()];
          } else {
            if (this.dateFormat === "dd_mm_no_dot") {
              value_0559 =
                value_0553.getDate() + " " + this.months[value_0553.getMonth()];
              value_0560 =
                value_0556.getDate() + " " + this.months[value_0556.getMonth()];
            } else {
              if (this.dateFormat === "day_dd_mm_numeric") {
                const value_0563 =
                    String(value_0553.getDate()).length > 1
                      ? value_0553.getDate()
                      : "0" + value_0553.getDate(),
                  value_0564 =
                    String(value_0553.getMonth() + 1).length > 1
                      ? value_0553.getMonth() + 1
                      : "0" + (value_0553.getMonth() + 1);
                value_0559 =
                  this.days[value_0553.getDay()] +
                  ", " +
                  value_0563 +
                  ". " +
                  value_0564 +
                  ".";
                const value_0565 =
                    String(value_0556.getDate()).length > 1
                      ? value_0556.getDate()
                      : "0" + value_0556.getDate(),
                  value_0566 =
                    String(value_0556.getMonth() + 1).length > 1
                      ? value_0556.getMonth() + 1
                      : "0" + (value_0556.getMonth() + 1);
                value_0560 =
                  this.days[value_0556.getDay()] +
                  ", " +
                  value_0565 +
                  ". " +
                  value_0566 +
                  ".";
              } else {
                if (this.dateFormat === "dd_mm_numeric") {
                  const value_0567 =
                      String(value_0553.getDate()).length > 1
                        ? value_0553.getDate()
                        : "0" + value_0553.getDate(),
                    value_0568 =
                      String(value_0553.getMonth() + 1).length > 1
                        ? value_0553.getMonth() + 1
                        : "0" + (value_0553.getMonth() + 1);
                  value_0559 = value_0567 + ". " + value_0568 + ".";
                  const value_0569 =
                      String(value_0556.getDate()).length > 1
                        ? value_0556.getDate()
                        : "0" + value_0556.getDate(),
                    value_0570 =
                      String(value_0556.getMonth() + 1).length > 1
                        ? value_0556.getMonth() + 1
                        : "0" + (value_0556.getMonth() + 1);
                  value_0560 = value_0569 + ". " + value_0570 + ".";
                } else {
                  value_0559 =
                    this.days[value_0553.getDay()] +
                    ", " +
                    this.months[value_0553.getMonth()] +
                    " " +
                    value_0553.getDate() +
                    value_0554;
                  value_0560 =
                    this.days[value_0556.getDay()] +
                    ", " +
                    this.months[value_0556.getMonth()] +
                    " " +
                    value_0556.getDate() +
                    value_0557;
                }
              }
            }
          }
        }
      }
      const value_0561 = value_0550.replace("[start_date]", value_0559),
        value_0562 = value_0561.replace("[end_date]", value_0560);
      // This template is merchant rich text and may contain allowed markup.
      parameter_0548.innerHTML = value_0562;
    });
  }
  rearrangeDays(parameter_0571) {
    return (
      parameter_0571.unshift(parameter_0571[6]),
      (parameter_0571.length = 7),
      parameter_0571
    );
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector(
      "#ProductSubmitButton-" + this.dataset.section,
    );
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    this.isAfterScroll
      ? this.mainAtcBtn &&
        (this.checkATCScroll(),
        document.addEventListener("scroll", this.checkATCScroll.bind(this)))
      : this.floatingBtns.forEach((parameter_0573) => {
          parameter_0573.style.setProperty(
            "--sticky-atc-offset",
            this.offsetHeight + "px",
          );
        });
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector(
        "" + this.dataset.scrollDestination.replace("id", this.dataset.section),
      );
      if (this.scrollBtn && this.scrollDestination)
        this.scrollBtn.addEventListener(
          "click",
          this.handleScrollBtn.bind(this),
        );
    }
  }
  checkATCScroll() {
    window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
      ? ((this.style.transform = "none"), (this.scrolledPast = true))
      : ((this.style.transform = ""), (this.scrolledPast = false));
    this.floatingBtns.forEach((parameter_0576) => {
      this.scrolledPast
        ? parameter_0576.style.setProperty(
            "--sticky-atc-offset",
            this.offsetHeight + "px",
          )
        : parameter_0576.style.setProperty("--sticky-atc-offset", "0px");
    });
  }
  handleScrollBtn() {
    const element_0579 = document.querySelector("sticky-header"),
      value_0580 = element_0579 ? element_0579.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - value_0580 - 15,
      behavior: "smooth",
    });
  }
  footerSpacing() {
    let element_0582 = document.querySelector(".sticky-atc-footer-spacer");
    if (element_0582) return;
    element_0582 = document.createElement("div");
    element_0582.className = "sticky-atc-footer-spacer";
    element_0582.style.height = this.clientHeight - 1 + "px";
    element_0582.style.display = "block";
    const element_0583 = document.querySelector(".footer");
    if (element_0583)
      element_0582.style.background =
        window.getComputedStyle(element_0583).background;
    document.body.appendChild(element_0582);
  }
}
customElements.define("sticky-atc", StickyAtc);
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(
      ".bundle-deals__media-item-container-js",
    );
    this.mediaItemImgs = this.querySelectorAll(
      ".bundle-deals__media-item-img-js",
    );
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(
      ".bundle-deals__variant-selects-js",
    );
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(
      ".bundle-deals__compare-price-js",
    );
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(
      ".bundle-deals__total-compare-price-js",
    );
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null,
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach((parameter_0585) => {
      parameter_0585.addEventListener(
        "change",
        this.handleCheckboxChange.bind(this),
      );
    });
    this.variantPickers.forEach((parameter_0587) => {
      parameter_0587.addEventListener(
        "change",
        this.handleSelectChange.bind(this),
      );
    });
  }
  initIds() {
    this.checkboxes.forEach((parameter_0590) => {
      this.selectedVariants[parameter_0590.dataset.idIndex] = {
        id: parameter_0590.dataset.id,
        price: parameter_0590.dataset.price,
        comparePrice: parameter_0590.dataset.comparePrice,
        checked: true,
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(parameter_0592) {
    const value_0594 = parameter_0592.currentTarget,
      value_0595 = value_0594.checked,
      value_0596 = parseInt(value_0594.dataset.index);
    this.selectedVariants[value_0594.dataset.idIndex].checked = value_0595;
    const value_0597 = this.productContainers[value_0596],
      elements_0598 = value_0597.querySelectorAll("select");
    value_0595
      ? (this.mediaItemContainers[value_0596].classList.remove(
          "bundle-deals__media-item--disabled",
        ),
        value_0597.classList.remove("bundle-deals__product--deselected"),
        elements_0598.forEach((parameter_0599) => {
          parameter_0599.removeAttribute("disabled");
        }))
      : (this.mediaItemContainers[value_0596].classList.add(
          "bundle-deals__media-item--disabled",
        ),
        value_0597.classList.add("bundle-deals__product--deselected"),
        elements_0598.forEach((parameter_0601) => {
          parameter_0601.setAttribute("disabled", "");
        }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  handleSelectChange(parameter_0603) {
    const value_0605 = parameter_0603.currentTarget,
      value_0606 = parseInt(value_0605.dataset.index),
      value_0607 = Array.from(
        value_0605.querySelectorAll("select"),
        (parameter_0618) => parameter_0618.value,
      ),
      value_0608 = JSON.parse(
        value_0605.querySelector('[type="application/json"]').textContent,
      ).filter(
        (parameter_0619) =>
          value_0605.querySelector(":checked").value === parameter_0619.option1,
      ),
      value_0609 = [...value_0605.querySelectorAll(".select--small")];
    updateVariantStatuses(value_0608, value_0609);
    const value_0610 = JSON.parse(
      value_0605.querySelector('[type="application/json"]').textContent,
    ).find((parameter_0620) => {
      return !parameter_0620.options
        .map((parameter_0622, parameter_0623) => {
          return value_0607[parameter_0623] === parameter_0622;
        })
        .includes(false);
    });
    if (!value_0610) {
      if (this.skipNonExistent)
        findAvailableVariant(
          value_0605,
          value_0607,
          false,
          true,
          this.skipUnavailable,
        );
      return;
    }
    if (this.skipUnavailable && !value_0610.available) {
      if (findAvailableVariant(value_0605, value_0607, false, true, true))
        return;
    }
    let {
      price: value_0611,
      compare_at_price: value_0612,
      featured_image: value_0613,
    } = value_0610;
    value_0611 = parseInt(value_0611);
    let value_0614 = value_0612 ? parseInt(value_0612) : value_0611;
    const value_0615 = value_0605.dataset.percentageLeft ?? 1,
      value_0616 = value_0605.dataset.fixedDiscount ?? 0;
    value_0611 = value_0611 * value_0615 - value_0616;
    if (value_0613) value_0613 = value_0613.src;
    const value_0617 = value_0610.id;
    this.selectedVariants[value_0605.dataset.idIndex].id = value_0617;
    this.selectedVariants[value_0605.dataset.idIndex].price = value_0611;
    this.selectedVariants[value_0605.dataset.idIndex].comparePrice = value_0614;
    this.updateFormIds();
    this.updatePrices &&
      ((this.prices[value_0606].innerHTML =
        this.currencySymbol + (value_0611 / 100).toFixed(2)),
      value_0614 > value_0611
        ? (this.comparePrices[value_0606].innerHTML =
            this.currencySymbol + (value_0614 / 100).toFixed(2))
        : (this.comparePrices[value_0606].innerHTML = ""),
      this.updateTotalPrice());
    value_0613 &&
      value_0613.length > 0 &&
      this.mediaItemImgs[value_0606] &&
      (this.mediaItemImgs[value_0606].src = value_0613);
  }
  updateFormIds() {
    const value_0625 = [],
      value_0626 = this.selectedVariants;
    for (const value_0627 in value_0626) {
      const value_0628 = value_0626[value_0627];
      if (value_0628 != null && value_0628.checked) {
        const value_0629 = value_0625.findIndex(
          (parameter_0630) => parameter_0630.id === value_0628.id,
        );
        value_0629 < 0
          ? value_0625.unshift({
              id: value_0628.id,
              quantity: 1,
            })
          : (value_0625[value_0629].quantity += 1);
      }
    }
    this.formVariants = value_0625;
  }
  updateTotalPrice() {
    const value_0632 = [],
      value_0633 = [],
      value_0634 = this.selectedVariants;
    for (const value_0638 in value_0634) {
      const value_0639 = value_0634[value_0638];
      value_0639 != null &&
        value_0639.checked &&
        (value_0632.push(parseInt(value_0639.price)),
        value_0633.push(parseInt(value_0639.comparePrice)));
    }
    const value_0635 = value_0632.reduce(
        (parameter_0640, parameter_0641) => parameter_0640 + parameter_0641,
        0,
      ),
      value_0636 = value_0635 * this.percentageLeft - this.fixedDiscount,
      value_0637 = value_0633.reduce(
        (parameter_0642, parameter_0643) => parameter_0642 + parameter_0643,
        0,
      );
    this.totalPrice.innerHTML =
      this.currencySymbol + (value_0636 / 100).toFixed(2);
    value_0637 > value_0636
      ? (this.totalComparePrice.innerHTML =
          this.currencySymbol + (value_0637 / 100).toFixed(2))
      : (this.totalComparePrice.innerHTML = "");
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById(
      "quantity-gifts-" + this.dataset.section,
    );
    this.inputs = this.querySelectorAll('input[name="quantity"]');
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector('[type="application/json"]');
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: [],
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    if (this.querySelector("input[checked]"))
      this.selectedQuantity = parseInt(
        this.querySelector("input[checked]").value,
      );
    this.variantSelects = this.querySelectorAll(
      ".quantity-break__selector-item",
    );
    this.updatePrices = this.dataset.updatePrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    if (this.hasVariants) this.initVariants();
    this.inputs.forEach((parameter_0645) => {
      parameter_0645.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach((parameter_0647) => {
      parameter_0647.addEventListener(
        "change",
        this.handleSelectChange.bind(this),
      );
    });
  }
  handleSelectChange(parameter_0649) {
    const value_0651 = parameter_0649.currentTarget,
      value_0652 = Array.from(
        value_0651.querySelectorAll("select"),
        (parameter_0673) => parameter_0673.value,
      );
    if (this.updateUnavailable) {
      const value_0674 = this.getVariantData().filter(
          (parameter_0676) =>
            value_0651.querySelector(":checked").value ===
            parameter_0676.option1,
        ),
        value_0675 = [...value_0651.querySelectorAll(".select--small")];
      updateVariantStatuses(value_0674, value_0675);
    }
    const value_0653 = this.getVariantData().find((parameter_0677) => {
      return !parameter_0677.options
        .map((parameter_0679, parameter_0680) => {
          return value_0652[parameter_0680] === parameter_0679;
        })
        .includes(false);
    });
    if (!value_0653) {
      if (this.skipNonExistent)
        findAvailableVariant(
          value_0651,
          value_0652,
          false,
          true,
          this.skipUnavailable,
        );
      return;
    }
    if (this.skipUnavailable && !value_0653.available) {
      if (findAvailableVariant(value_0651, value_0652, false, true, true))
        return;
    }
    value_0651.dataset.selectedId = value_0653.id;
    const value_0654 = value_0651.dataset.selectIndex,
      value_0655 = value_0651.closest(".quantity-break"),
      value_0656 = value_0655.dataset.input;
    this.selectedVariants[value_0656][value_0654] = value_0653.id;
    this.formVariants = this.selectedVariants[value_0656];
    this.updateMedia(value_0653);
    if (!this.updatePrices) return;
    var value_0657 = 0,
      value_0658 = 0;
    const value_0659 = parseFloat(value_0655.dataset.quantity),
      value_0660 = parseFloat(value_0655.dataset.percentageLeft),
      value_0661 = parseFloat(value_0655.dataset.fixedDiscount);
    for (let value_0681 = 0; value_0681 < value_0659; value_0681++) {
      const value_0682 = parseInt(
          this.selectedVariants[value_0656][value_0681],
        ),
        value_0683 = this.getVariantData().find(
          (parameter_0684) => parseInt(parameter_0684.id) === value_0682,
        );
      if (!value_0683) return;
      value_0657 += value_0683.price;
      value_0683.compare_at_price &&
      value_0683.compare_at_price > value_0683.price
        ? (value_0658 += value_0683.compare_at_price)
        : (value_0658 += value_0683.price);
    }
    value_0657 = value_0657 * value_0660 - value_0661;
    const value_0662 = value_0658 - value_0657,
      value_0663 = Math.round(value_0662 / 100) * 100,
      value_0664 = value_0657 / value_0659,
      value_0665 = value_0658 / value_0659,
      value_0666 = formatMoney(value_0657, this.moneyFormat, true),
      value_0667 = formatMoney(value_0658, this.moneyFormat, true),
      value_0668 = formatMoney(value_0662, this.moneyFormat, true),
      value_0669 = formatMoney(value_0663, this.moneyFormat, true),
      value_0670 = formatMoney(value_0664, this.moneyFormat, true),
      value_0671 = formatMoney(value_0665, this.moneyFormat, true);
    value_0655
      .querySelectorAll(".variant-price-update")
      .forEach((parameter_0685) => {
        let value_0687 = parameter_0685.dataset.text;
        value_0687 = value_0687.replace("[quantity]", value_0659);
        value_0687 = value_0687.replace("[price]", value_0666);
        value_0687 = value_0687.replace("[compare_price]", value_0667);
        value_0687 = value_0687.replace("[amount_saved]", value_0668);
        value_0687 = value_0687.replace("[amount_saved_rounded]", value_0669);
        value_0687 = value_0687.replace("[price_each]", value_0670);
        value_0687 = value_0687.replace("[compare_price_each]", value_0671);
        parameter_0685.innerHTML = value_0687;
      });
    const element_0672 = value_0655.querySelector(
      ".quantity-break__compare-price",
    );
    element_0672 &&
      (value_0658 > value_0657
        ? element_0672.classList.remove("hidden")
        : element_0672.classList.add("hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach((parameter_0690) => {
      if (parameter_0690.querySelector(".quantity-break__variants")) {
        let value_0692 = [];
        parameter_0690
          .querySelectorAll(".quantity-break__selector-item")
          .forEach((parameter_0693) => {
            value_0692.push(parameter_0693.dataset.selectedId);
          });
        this.selectedVariants[parameter_0690.dataset.input] = value_0692;
      }
    });
    this.formVariants = [];
  }
  updateMedia(parameter_0695) {
    if (!parameter_0695) return;
    if (!parameter_0695.featured_media) return;
    const elements_0697 = document.querySelectorAll(
      '[id^="MediaGallery-' + this.dataset.section + '"]',
    );
    elements_0697.forEach((parameter_0698) =>
      parameter_0698.setActiveMedia(
        this.dataset.section + "-" + parameter_0695.featured_media.id,
        true,
      ),
    );
  }
  handleChange(parameter_0699) {
    const value_0701 = parseInt(parameter_0699.target.value);
    this.selectedQuantity = value_0701;
    if (this.hasVariants)
      this.formVariants =
        this.selectedVariants[parameter_0699.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(value_0701);
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function updateVariantStatuses(parameter_0702, parameter_0703) {
  parameter_0703.forEach((parameter_0705, parameter_0706) => {
    if (parameter_0706 === 0) return;
    const value_0708 = [...parameter_0705.querySelectorAll("option")],
      value_0709 =
        parameter_0703[parameter_0706 - 1].querySelector(":checked").value,
      value_0710 = parameter_0702
        .filter(
          (parameter_0712) =>
            parameter_0712.available &&
            parameter_0712["option" + parameter_0706] === value_0709,
        )
        .map(
          (parameter_0713) => parameter_0713["option" + (parameter_0706 + 1)],
        ),
      value_0711 = parameter_0702
        .filter(
          (parameter_0714) =>
            parameter_0714["option" + parameter_0706] === value_0709,
        )
        .map(
          (parameter_0715) => parameter_0715["option" + (parameter_0706 + 1)],
        );
    value_0708.forEach((parameter_0716) => {
      parameter_0716.classList.remove("unavailable", "non-existent");
      value_0711.includes(parameter_0716.getAttribute("value"))
        ? value_0710.includes(parameter_0716.getAttribute("value"))
          ? (parameter_0716.innerText = parameter_0716.getAttribute("value"))
          : ((parameter_0716.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                parameter_0716.getAttribute("value"),
              )),
            parameter_0716.classList.add("unavailable"))
        : ((parameter_0716.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              parameter_0716.getAttribute("value"),
            )),
          parameter_0716.classList.add("non-existent"));
    });
  });
}
function findAvailableVariant(
  parameter_0718,
  parameter_0719,
  parameter_0720 = true,
  parameter_0721 = false,
  parameter_0722 = false,
) {
  console.log("Running findAvailableVariant");
  for (
    let value_0724 = parameter_0719.length - 1;
    value_0724 >= 0;
    value_0724--
  ) {
    const value_0725 = parameter_0720
        ? parameter_0718.querySelector(
            ".product-form__input:nth-child(" + (value_0724 + 1) + ")",
          )
        : parameter_0718.querySelectorAll(".select")[value_0724],
      value_0726 = parameter_0720
        ? value_0725.querySelector(".product-form__input__type").dataset.type
        : "dropdown",
      value_0727 =
        value_0726 === "dropdown"
          ? value_0725.querySelectorAll("option")
          : value_0725.querySelectorAll('input[type="radio"]');
    let value_0728 = Array.from(value_0727).findIndex(
        (parameter_0730) => parameter_0730.value === parameter_0719[value_0724],
      ),
      value_0729 = false;
    while (value_0728 < value_0727.length - 1) {
      value_0728++;
      const value_0731 = value_0727[value_0728];
      if (
        (!parameter_0721 || !value_0731.classList.contains("non-existent")) &&
        (!parameter_0722 || !value_0731.classList.contains("unavailable"))
      ) {
        parameter_0719[value_0724] = value_0731.value;
        value_0729 = true;
        break;
      }
    }
    if (!value_0729) {
      value_0728 = Array.from(value_0727).findIndex(
        (parameter_0732) => parameter_0732.value === parameter_0719[value_0724],
      );
      while (value_0728 > 0) {
        value_0728--;
        const value_0733 = value_0727[value_0728];
        if (
          (!parameter_0721 || !value_0733.classList.contains("non-existent")) &&
          (!parameter_0722 || !value_0733.classList.contains("unavailable"))
        ) {
          parameter_0719[value_0724] = value_0733.value;
          value_0729 = true;
          break;
        }
      }
    }
    if (value_0729)
      return (
        value_0726 === "dropdown"
          ? (value_0725.querySelector(".select__select").value =
              parameter_0719[value_0724])
          : (value_0725.querySelector(
              'input[type="radio"][value="' + parameter_0719[value_0724] + '"]',
            ).checked = true),
        parameter_0718.dispatchEvent(new Event("change")),
        true
      );
  }
  return false;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById(
      "quantity-breaks-" + this.dataset.section,
    );
    this.quantitySelector = document.getElementById(
      "Quantity-Form--" + this.dataset.section,
    );
    this.unlockedItems = [];
    this.initUnlock();
  }
  initUnlock() {
    let value_0736 = 1;
    if (this.quantityBreaks)
      value_0736 = parseInt(this.quantityBreaks.selectedQuantity);
    else {
      if (this.quantitySelector) {
        const element_0737 = this.quantitySelector.querySelector(
          'input[name="quantity"]',
        );
        value_0736 = parseInt(element_0737.value);
      }
    }
    this.unlockGifts(value_0736);
  }
  unlockGifts(parameter_0738) {
    this.unlockedItems = [];
    this.gifts.forEach((parameter_0740) => {
      parseInt(parameter_0740.dataset.quantity) <= parameter_0738
        ? (parameter_0740.classList.add("quantity-gift--unlocked"),
          (parameter_0740.dataset.unlocked = "true"),
          this.unlockedItems.unshift(parameter_0740.dataset.product))
        : (parameter_0740.classList.remove("quantity-gift--unlocked"),
          (parameter_0740.dataset.unlocked = "false"));
    });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector('[type="application/json"]');
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(
        ".upsell__price .compare-price",
      );
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem)
        this.mainOfferContainer = document.querySelector(
          "#MainBundleOffer-" + this.dataset.section,
        );
    }
    if (this.toggleBtn)
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    if (this.variantSelects)
      this.variantSelects.addEventListener(
        "change",
        this.handleSelectChange.bind(this),
      );
  }
  handleToggle(parameter_0743) {
    if (
      parameter_0743.target.nodeName.toLowerCase() === "select" ||
      parameter_0743.target.nodeName.toLowerCase() === "option"
    )
      return;
    this.dataset.selected === "true"
      ? (this.dataset.selected = "false")
      : (this.dataset.selected = "true");
  }
  handleSelectChange(parameter_0745) {
    const value_0747 = parameter_0745.currentTarget,
      value_0748 = Array.from(
        value_0747.querySelectorAll("select"),
        (parameter_0752) => parameter_0752.value,
      ),
      value_0749 = this.getVariantData().find((parameter_0753) => {
        return !parameter_0753.options
          .map((parameter_0755, parameter_0756) => {
            return value_0748[parameter_0756] === parameter_0755;
          })
          .includes(false);
      }),
      value_0750 = this.getVariantData().filter(
        (parameter_0757) =>
          value_0747.querySelector(":checked").value === parameter_0757.option1,
      ),
      value_0751 = [...value_0747.querySelectorAll("select")];
    updateVariantStatuses(value_0750, value_0751);
    if (!value_0749) {
      if (this.skipNonExistent)
        findAvailableVariant(
          value_0747,
          value_0748,
          false,
          true,
          this.skipUnavailable,
        );
      return;
    }
    if (this.skipUnavailable && !value_0749.available) {
      if (findAvailableVariant(value_0747, value_0748, false, true, true))
        return;
    }
    this.updatePrices &&
      ((this.price =
        value_0749.price * this.percentageLeft - this.fixedDiscount),
      (this.comparePrice = value_0749.price),
      value_0749.compare_at_price &&
        value_0749.compare_at_price > value_0749.price &&
        (this.comparePrice = value_0749.compare_at_price),
      displayPrices(
        this.price,
        this.comparePrice,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat,
      ));
    if (this.image && value_0749.featured_image)
      this.image.src = value_0749.featured_image.src;
    this.updateId(value_0749.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices)
      this.mainOfferContainer.updateTotalPrices();
  }
  updateId(parameter_0758) {
    this.dataset.id = parameter_0758;
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
    this.productForm = this.querySelector("product-form");
    this.idInput = this.productForm.querySelector('[name="id"]');
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(parameter_0762) {
    if (
      parameter_0762.target.nodeName.toLowerCase() === "select" ||
      parameter_0762.target.nodeName.toLowerCase() === "option"
    )
      return;
    this.dataset.selected === "true"
      ? ((this.dataset.selected = "false"), this.removeFromCart())
      : ((this.dataset.selected = "true"), this.addToCart());
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" &&
    !this.cartDrawer.classList.contains("is-empty")
      ? this.addToCart()
      : this.removeFromCart();
  }
  addToCart() {
    const element_0766 = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle,
    );
    if (element_0766) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach((parameter_0767) => {
      parameter_0767.setAttribute("disabled", "");
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const element_0770 = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle,
    );
    if (!element_0770 || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach((parameter_0771) => {
      parameter_0771.setAttribute("disabled", "");
    });
    this.cartItems.updateQuantity(element_0770.dataset.index, 0);
  }
  updateId(parameter_0773) {
    this.dataset.id = parameter_0773;
    this.idInput.value = parameter_0773;
    if (this.classicAddButton) return;
    if (this.dataset.selected === "true") {
      this.selectTimeout && clearTimeout(this.selectTimeout);
      this.removeFromCart();
      const value_0775 = (parameter_0776) => {
        parameter_0776.detail.handle === "handle" &&
          (this.addToCart(),
          document.removeEventListener("cartQuantityUpdated", value_0775));
      };
      document.addEventListener("cartQuantityUpdated", value_0775);
    }
  }
  getUpdateRequired() {
    const element_0779 = this.cartDrawer.querySelector(
      ".cart-item--product-" + this.dataset.handle,
    );
    let value_0780 = false;
    if (element_0779 && this.dataset.selected === "false") value_0780 = true;
    else
      !element_0779 && this.dataset.selected === "true" && (value_0780 = true);
    return value_0780;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(
  parameter_0781,
  parameter_0782,
  parameter_0783,
  parameter_0784,
  parameter_0785,
) {
  if (!parameter_0785) return;
  if (parameter_0781 && parameter_0783) {
    var value_0787 = formatMoney(parameter_0781, parameter_0785);
    parameter_0783.innerHTML = value_0787;
  }
  if (parameter_0782 && parameter_0784) {
    var value_0788 = formatMoney(parameter_0782, parameter_0785);
    parameter_0784.innerHTML = value_0788;
    parameter_0782 > parameter_0781
      ? parameter_0784.classList.remove("hidden")
      : parameter_0784.classList.add("hidden");
  }
}
function formatMoney(parameter_0789, parameter_0790, parameter_0791 = false) {
  typeof parameter_0789 == "string" &&
    (parameter_0789 = parameter_0789.replace(".", ""));
  var value_0793 = "",
    value_0794 = /\{\{\s*(\w+)\s*\}\}/,
    value_0795 = parameter_0790;
  function function_0796(parameter_0798, parameter_0799) {
    return typeof parameter_0798 == "undefined"
      ? parameter_0799
      : parameter_0798;
  }
  function function_0797(
    parameter_0800,
    parameter_0801,
    parameter_0802,
    parameter_0803,
  ) {
    parameter_0801 = function_0796(parameter_0801, 2);
    parameter_0802 = function_0796(parameter_0802, ",");
    parameter_0803 = function_0796(parameter_0803, ".");
    if (isNaN(parameter_0800) || parameter_0800 == null) return 0;
    parameter_0800 = (parameter_0800 / 100).toFixed(parameter_0801);
    var value_0805 = parameter_0800.split("."),
      value_0806 = value_0805[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + parameter_0802,
      ),
      value_0807 = value_0805[1] ? parameter_0803 + value_0805[1] : "";
    return (
      parameter_0791 &&
        value_0807 === parameter_0803 + "00" &&
        (value_0807 = ""),
      value_0806 + value_0807
    );
  }
  switch (value_0795.match(value_0794)[1]) {
    case "amount":
      value_0793 = function_0797(parameter_0789, 2);
      break;
    case "amount_no_decimals":
      value_0793 = function_0797(parameter_0789, 0);
      break;
    case "amount_with_comma_separator":
      value_0793 = function_0797(parameter_0789, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value_0793 = function_0797(parameter_0789, 0, ".", ",");
      break;
  }
  return value_0795.replace(value_0794, value_0793);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const element_0809 = document.querySelector("cart-drawer");
  element_0809 &&
    element_0809
      .querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
      )
      .forEach((parameter_0810) => {
        if (parameter_0810.addRemoveFromCart)
          parameter_0810.addRemoveFromCart();
      });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.updatePrices &&
      ((this.priceSpan = this.querySelector(".bundle-deals__total-price-js")),
      (this.comparePriceSpan = this.querySelector(
        ".bundle-deals__total-compare-price-js",
      )),
      (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
      (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
      (this.moneyFormat = this.dataset.moneyFormat));
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    var value_0814 = 0,
      value_0815 = 0;
    for (
      let value_0816 = 0;
      value_0816 < this.offerItems.length;
      value_0816++
    ) {
      value_0814 += parseInt(this.offerItems[value_0816].price);
      value_0815 += parseInt(this.offerItems[value_0816].comparePrice);
    }
    value_0814 = value_0814 * this.percentageLeft - this.fixedDiscount;
    displayPrices(
      value_0814,
      value_0815,
      this.priceSpan,
      this.comparePriceSpan,
      this.moneyFormat,
    );
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector('[type="text"], [type="number"], textarea');
    this.inputRadios = this.querySelectorAll('[type="radio"]');
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById(
      "product-form-" + this.dataset.section,
    );
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills")
      this.isText = false;
    this.createInputs();
    this.isRequired &&
      this.isText &&
      ((this.isValid = true),
      (this.atcButtons = this.notMain
        ? document.querySelectorAll(
            ".featured-product-atc-" + this.dataset.section,
          )
        : document.querySelectorAll(".main-product-atc")),
      (this.mainAtcButton = this.productForm.querySelector(
        "#ProductSubmitButton-" + this.dataset.section,
      )),
      (this.mainAtcBtnLabel =
        this.mainAtcButton.querySelector(".main-atc__label")),
      (this.mainAtcBtnError =
        this.mainAtcButton.querySelector(".main-atc__error")),
      (this.atcErrorMsg = this.dataset.atcErrorMsg),
      (this.mainAtcButton.dataset.requiredFields =
        parseInt(this.mainAtcButton.dataset.requiredFields) + 1),
      (this.mainAtcBtnError.textContent = this.atcErrorMsg),
      (this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true"),
      (this.stickyAtcButton = document.querySelector(
        "#sticky-atc-" + this.dataset.section,
      )),
      this.applyStickyAtcError &&
        this.stickyAtcButton &&
        ((this.stickyAtcBtnLabel =
          this.stickyAtcButton.querySelector(".sticky-atc__label")),
        (this.stickyAtcBtnError =
          this.stickyAtcButton.querySelector(".sticky-atc__error")),
        (this.stickyAtcBtnError.textContent = this.atcErrorMsg)),
      this.validateValue(this.prevValue, null));
    if (this.input)
      this.input.addEventListener("input", this.handleChange.bind(this));
    this.inputRadios.forEach((parameter_0818) => {
      parameter_0818.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select)
      this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(parameter_0820) {
    const value_0822 = parameter_0820.target.value.trim();
    if (parameter_0820.target.checkValidity()) this.prevValue = value_0822;
    else {
      parameter_0820.target.value = this.prevValue;
      return;
    }
    this.dataset.value = value_0822;
    this.productFormInput.value = value_0822;
    if (this.isRequired && this.isText)
      this.validateValue(value_0822, parameter_0820.target);
  }
  validateValue(parameter_0823, parameter_0824) {
    const value_0826 = parameter_0823.length > 0 ? true : false;
    if (value_0826 === this.isValid) return;
    this.isValid = value_0826;
    parameter_0824 &&
      (this.isValid
        ? (parameter_0824.classList.remove("input--error"),
          (this.mainAtcButton.dataset.validFields =
            parseInt(this.mainAtcButton.dataset.validFields) + 1))
        : (parameter_0824.classList.add("input--error"),
          (this.mainAtcButton.dataset.validFields =
            parseInt(this.mainAtcButton.dataset.validFields) - 1)));
    const value_0827 =
        this.mainAtcButton.dataset.validFields ===
        this.mainAtcButton.dataset.requiredFields,
      value_0828 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach((parameter_0829) => {
      value_0827 && !value_0828
        ? parameter_0829.removeAttribute("disabled")
        : parameter_0829.setAttribute("disabled", "");
    });
    if (this.atcErrorMsg.length === 0) return;
    value_0827
      ? ((this.mainAtcBtnLabel.style.display = ""),
        (this.mainAtcBtnError.style.display = "none"),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = ""),
          (this.stickyAtcBtnError.style.display = "none")))
      : ((this.mainAtcBtnLabel.style.display = "none"),
        (this.mainAtcBtnError.style.display = ""),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = "none"),
          (this.stickyAtcBtnError.style.display = "")));
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute(
      "name",
      "properties[" + this.fieldName + "]",
    );
    this.productFormInput.value = this.dataset.defaultValue;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById(
      "quantity-breaks-" + this.dataset.section,
    );
    this.hasQuantityBreaksPicker =
      this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.hasQuantityBreaksPicker &&
      ((this.quantityBreaksPickerStyle =
        this.dataset.quantityBreaksPickerStyle),
      (this.quantityBreaksPickerDisplayedImages =
        this.dataset.quantityBreaksPickerDisplayedImages));
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (
        this.skipNonExistent &&
        findAvailableVariant(
          this,
          this.options,
          true,
          true,
          this.skipUnavailable,
        )
      )
        return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const value_0835 = [];
    this.querySelectorAll(".product-form__input").forEach((parameter_0836) => {
      let value_0838;
      const value_0839 = parameter_0836.querySelector(
        ".product-form__input__type",
      ).dataset.type;
      value_0839 == "dropdown" || value_0839 == "dropdwon"
        ? (value_0838 = parameter_0836.querySelector(".select__select").value)
        : (value_0838 = parameter_0836.querySelector(
            'input[type="radio"]:checked',
          ).value);
      value_0835.push(value_0838);
    });
    this.options = value_0835;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((parameter_0841) => {
      return !parameter_0841.options
        .map((parameter_0843, parameter_0844) => {
          return this.options[parameter_0844] === parameter_0843;
        })
        .includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const elements_0847 = document.querySelectorAll(
      '[id^="MediaGallery-' + this.dataset.section + '"]',
    );
    elements_0847.forEach((parameter_0850) =>
      parameter_0850.setActiveMedia(
        this.dataset.section + "-" + this.currentVariant.featured_media.id,
        this.prependMedia,
        this.filtering,
        this.currentVariant,
      ),
    );
    const element_0848 = document.querySelector(
      "#ProductModal-" +
        this.dataset.section +
        " .product-media-modal__content",
    );
    if (!element_0848) return;
    const element_0849 = element_0848.querySelector(
      '[data-media-id="' + this.currentVariant.featured_media.id + '"]',
    );
    element_0848.prepend(element_0849);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      this.dataset.url + "?variant=" + this.currentVariant.id,
    );
  }
  updateShareUrl() {
    const value_0853 = document.getElementById("Share-" + this.dataset.section);
    if (!value_0853 || !value_0853.updateUrl) return;
    value_0853.updateUrl(
      "" +
        window.shopUrl +
        this.dataset.url +
        "?variant=" +
        this.currentVariant.id,
    );
  }
  updateVariantInput() {
    const elements_0855 = document.querySelectorAll(
      "#product-form-" +
        this.dataset.section +
        ", #product-form-installment-" +
        this.dataset.section,
    );
    elements_0855.forEach((parameter_0856) => {
      const element_0858 = parameter_0856.querySelector('input[name="id"]');
      element_0858.value = this.currentVariant.id;
      element_0858.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );
    });
  }
  updateVariantStatuses() {
    const value_0860 = this.variantData.filter(
      (parameter_0862) =>
        this.querySelector(":checked").value === parameter_0862.option1,
    );
    let value_0861;
    this.isSecondary && this.secondarySelect
      ? (value_0861 = [
          ...this.secondarySelect.querySelectorAll(".product-form__input"),
        ])
      : (value_0861 = [...this.querySelectorAll(".product-form__input")]);
    value_0861.forEach((parameter_0863, parameter_0864) => {
      if (parameter_0864 === 0) return;
      const value_0866 = [
          ...parameter_0863.querySelectorAll(
            'input[type="radio"], .select__select option',
          ),
        ],
        value_0867 =
          value_0861[parameter_0864 - 1].querySelector(":checked").value,
        value_0868 = value_0860
          .filter(
            (parameter_0870) =>
              parameter_0870.available &&
              parameter_0870["option" + parameter_0864] === value_0867,
          )
          .map(
            (parameter_0871) => parameter_0871["option" + (parameter_0864 + 1)],
          ),
        value_0869 = value_0860
          .filter(
            (parameter_0872) =>
              parameter_0872["option" + parameter_0864] === value_0867,
          )
          .map(
            (parameter_0873) => parameter_0873["option" + (parameter_0864 + 1)],
          );
      this.setInputAvailability(value_0866, value_0868, value_0869);
    });
  }
  setInputAvailability(parameter_0874, parameter_0875, parameter_0876) {
    parameter_0874.forEach((parameter_0877) => {
      parameter_0877.classList.remove(
        "unavailable",
        "non-existent",
        "disabled",
      );
      const value_0879 = parameter_0877.getAttribute("value");
      let value_0880 = null;
      parameter_0877.dataset.swatch === "true" &&
        (value_0880 = parameter_0877.closest(".color-swatch"));
      if (value_0880)
        value_0880.classList.remove("unavailable", "non-existent", "disabled");
      if (parameter_0876.includes(value_0879)) {
        if (parameter_0875.includes(value_0879)) {
          if (parameter_0877.nodeName === "OPTION")
            parameter_0877.innerText = value_0879;
          else {
            parameter_0877.classList.remove("disabled");
            if (value_0880) value_0880.classList.remove("disabled");
          }
        } else {
          if (parameter_0877.nodeName === "OPTION") {
            parameter_0877.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                value_0879,
              );
            parameter_0877.classList.add("unavailable");
          } else {
            parameter_0877.classList.add("disabled", "unavailable");
            if (value_0880) value_0880.classList.add("disabled", "unavailable");
          }
        }
      } else {
        if (parameter_0877.nodeName === "OPTION") {
          parameter_0877.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value_0879,
            );
          parameter_0877.classList.add("non-existent");
        } else {
          parameter_0877.classList.add("disabled", "non-existent");
          if (value_0880) value_0880.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const element_0882 = document.querySelector("pickup-availability");
    if (!element_0882) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (element_0882.fetchAvailability)
        element_0882.fetchAvailability(this.currentVariant.id);
    } else {
      element_0882.removeAttribute("available");
      element_0882.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const value_0884 = this.closest("section");
    if (!value_0884) return;
    const element_0885 = value_0884.querySelector("product-form");
    if (element_0885) element_0885.handleErrorMessage();
  }
  renderProductInfo() {
    const value_0887 = this.currentVariant.id,
      value_0888 = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      this.dataset.url +
        "?variant=" +
        value_0887 +
        "&section_id=" +
        (this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section),
    )
      .then((parameter_0889) => parameter_0889.text())
      .then((parameter_0890) => {
        if (this.currentVariant.id !== value_0887) return;
        const documentFragment_0892 = new DOMParser().parseFromString(
            parameter_0890,
            "text/html",
          ),
          value_0893 = document.getElementById("price-" + this.dataset.section),
          value_0894 = documentFragment_0892.getElementById(
            "price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          value_0895 = document.getElementById(
            "sticky-atc-separate-price-" + this.dataset.section,
          ),
          value_0896 = documentFragment_0892.getElementById(
            "sticky-atc-separate-price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          value_0897 = document.getElementById(
            "sticky-atc-price-" + this.dataset.section,
          ),
          value_0898 = documentFragment_0892.getElementById(
            "sticky-atc-price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          value_0899 = document.getElementById(
            "sticky-atc-image-" + this.dataset.section,
          ),
          value_0900 = documentFragment_0892.getElementById(
            "sticky-atc-image-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          value_0901 = document.getElementById(
            "main-atc-price-" + this.dataset.section,
          ),
          value_0902 = documentFragment_0892.getElementById(
            "main-atc-price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          elements_0903 = document.querySelectorAll(
            '[id^="custom-label-' + this.dataset.section + '"]',
          ),
          elements_0904 = documentFragment_0892.querySelectorAll(
            '[id^="custom-label-' +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section) +
              '"]',
          ),
          value_0905 = documentFragment_0892.getElementById(
            "Sku-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          value_0906 = document.getElementById("Sku-" + this.dataset.section),
          value_0907 = documentFragment_0892.getElementById(
            "Inventory-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          value_0908 = document.getElementById(
            "Inventory-" + this.dataset.section,
          );
        if (value_0893 && value_0894)
          value_0893.innerHTML = value_0894.innerHTML;
        if (value_0895 && value_0896)
          value_0895.innerHTML = value_0896.innerHTML;
        if (value_0897 && value_0898)
          value_0897.innerHTML = value_0898.innerHTML;
        if (value_0899 && value_0900) value_0899.src = value_0900.src;
        if (value_0902 && value_0901)
          value_0901.innerHTML = value_0902.innerHTML;
        if (elements_0903 && elements_0904)
          for (
            var value_0909 = 0;
            value_0909 < elements_0903.length;
            value_0909++
          ) {
            elements_0903[value_0909].innerHTML =
              elements_0904[value_0909].innerHTML;
          }
        if (value_0907 && value_0908)
          value_0908.innerHTML = value_0907.innerHTML;
        value_0905 &&
          value_0906 &&
          ((value_0906.innerHTML = value_0905.innerHTML),
          value_0906.classList.toggle(
            "visibility-hidden",
            value_0905.classList.contains("visibility-hidden"),
          ));
        if (this.QuantityBreaks) {
          const value_0912 = documentFragment_0892.getElementById(
              "quantity-breaks-" +
                (this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section),
            ),
            elements_0913 =
              this.QuantityBreaks.querySelectorAll(".dynamic-price"),
            elements_0914 = value_0912.querySelectorAll(".dynamic-price");
          for (
            let value_0915 = 0;
            value_0915 < elements_0913.length;
            value_0915++
          ) {
            elements_0913[value_0915].innerHTML =
              elements_0914[value_0915].innerHTML;
          }
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((parameter_0918) => {
              parameter_0918.dataset.selectedId = this.currentVariant.id;
            });
            const elements_0916 = this.QuantityBreaks.querySelectorAll(
                ".quantity-break__variant-select",
              ),
              elements_0917 = value_0912.querySelectorAll(
                ".quantity-break__variant-select",
              );
            for (
              let value_0920 = 0;
              value_0920 < elements_0916.length;
              value_0920++
            ) {
              elements_0916[value_0920].innerHTML =
                elements_0917[value_0920].innerHTML;
            }
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const value_0921 = documentFragment_0892.getElementById(
              "variant-selects-" +
                (this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section),
            ),
            elements_0922 = this.querySelectorAll(".dynamic-price"),
            elements_0923 = value_0921.querySelectorAll(".dynamic-price");
          for (
            let value_0924 = 0;
            value_0924 < elements_0922.length;
            value_0924++
          ) {
            elements_0922[value_0924].innerHTML =
              elements_0923[value_0924].innerHTML;
          }
          if (
            this.quantityBreaksPickerStyle === "vertical" &&
            this.quantityBreaksPickerDisplayedImages === "variant_images"
          ) {
            const elements_0925 = this.querySelectorAll(
                ".quantity-break__image img",
              ),
              elements_0926 = value_0921.querySelectorAll(
                ".quantity-break__image img",
              );
            for (
              let value_0927 = 0;
              value_0927 < elements_0925.length;
              value_0927++
            ) {
              elements_0925[value_0927].src = elements_0926[value_0927].src;
            }
          }
        }
        if (this.secondarySelect) {
          const value_0928 = documentFragment_0892.getElementById(
            "" +
              this.secondarySelectSelector +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          );
          if (value_0928) this.secondarySelect.innerHTML = value_0928.innerHTML;
        }
        const value_0910 = document.getElementById(
          "price-" + this.dataset.section,
        );
        if (value_0910) value_0910.classList.remove("visibility-hidden");
        if (value_0908)
          value_0908.classList.toggle(
            "visibility-hidden",
            value_0907.innerText === "",
          );
        const value_0911 = documentFragment_0892.getElementById(
          "ProductSubmitButton-" + value_0888,
        );
        this.toggleAddButton(
          value_0911 ? value_0911.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
        );
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: value_0888,
            html: documentFragment_0892,
            variant: this.currentVariant,
          },
        });
      });
  }
  toggleAddButton(
    parameter_0929 = true,
    parameter_0930,
    parameter_0931 = true,
  ) {
    const value_0933 = document.getElementById(
      "product-form-" + this.dataset.section,
    );
    if (!value_0933) return;
    const element_0934 = value_0933.querySelector('[name="add"]'),
      elements_0935 = document.querySelectorAll(".main-product-atc");
    var element_0936 = value_0933.querySelector(".main-atc__label__text");
    if (!element_0936)
      element_0936 = value_0933.querySelector(".main-atc__label");
    const element_0937 = value_0933.querySelector(".main-atc-price");
    if (!element_0934) return;
    if (parameter_0929) {
      element_0934.setAttribute("disabled", "disabled");
      element_0934.setAttribute("data-unavailable", "true");
      if (parameter_0930) element_0936.textContent = parameter_0930;
      elements_0935.forEach((parameter_0938) => {
        parameter_0938.setAttribute("disabled", "disabled");
      });
      if (element_0937) element_0937.classList.add("hidden");
    } else {
      element_0934.setAttribute("data-unavailable", "false");
      element_0936.textContent = window.variantStrings.addToCart;
      if (element_0937) element_0937.classList.remove("hidden");
      element_0934.dataset.requiredFields ===
        element_0934.dataset.validFields &&
        (element_0934.removeAttribute("disabled"),
        elements_0935.forEach((parameter_0940) => {
          parameter_0940.removeAttribute("disabled");
        }));
    }
    if (!parameter_0931) return;
  }
  setUnavailable() {
    const value_0943 = document.getElementById(
      "product-form-" + this.dataset.section,
    );
    if (!value_0943) return;
    const element_0944 = value_0943.querySelector('[name="add"]');
    var element_0945 = value_0943.querySelector(".main-atc__label__text");
    if (!element_0945)
      element_0945 = value_0943.querySelector(".main-atc__label");
    const value_0946 = document.getElementById("price-" + this.dataset.section),
      value_0947 = document.getElementById("Inventory-" + this.dataset.section),
      value_0948 = document.getElementById("Sku-" + this.dataset.section);
    if (!element_0944) return;
    element_0945.textContent = window.variantStrings.unavailable;
    if (value_0946) value_0946.classList.add("visibility-hidden");
    if (value_0947) value_0947.classList.add("visibility-hidden");
    if (value_0948) value_0948.classList.add("visibility-hidden");
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent,
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = true;
  }
}
customElements.define(
  "secondary-variant-select-separate",
  SecondaryVariantSelectSeparate,
);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(
      this.dataset.section + "-submit",
    );
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    !this.currentVariant
      ? (this.toggleAddButton(true, "", true), this.setUnavailable())
      : (this.updateMedia(),
        this.updateVariantInput(),
        this.updateQuickAddUrl(),
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        ));
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const value_0956 = document.getElementById(this.dataset.section + "-image");
    if (!value_0956) return;
    const value_0957 = this.currentVariant.featured_media.preview_image,
      value_0958 = value_0957.src.split("?")[0],
      value_0959 = [165, 360, 533, 720, 940, 1066],
      value_0960 = value_0959
        .filter((parameter_0961) => value_0957.width >= parameter_0961)
        .map(
          (parameter_0962) =>
            value_0958 +
            "?width=" +
            parameter_0962 +
            " " +
            parameter_0962 +
            "w",
        )
        .join(", ");
    value_0956.srcset =
      value_0960 + ", " + value_0958 + " " + value_0957.width + "w";
    value_0956.src = value_0958 + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl =
      this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
